import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import axios from 'axios';
import { toast } from "react-toastify";
import "./ViewTaskss.css";
import ManagerNavbar from "../Layout/ManagerNavbar";
import API_BASE_URL from "../config";
import { format } from "date-fns";
import "./Worklogs.css";


const ViewTaskss = () => {
    const [isFullscreen, setIsFullscreen] = useState(false);
    const [tasks, setTasks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [activeTask, setActiveTask] = useState(null);
    const [comments, setComments] = useState([]);
    const [editingCommentId, setEditingCommentId] = useState(null);
    const [editContent, setEditContent] = useState("");
    const [replyToCommentId, setReplyToCommentId] = useState(null);
    const [replyContent, setReplyContent] = useState("");
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [attachments, setAttachments] = useState([]);
    const [mentionableUsers, setMentionableUsers] = useState([]);
    const [mentions, setMentions] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [savedRange, setSavedRange] = useState(null);

    const [projects, setProjects] = useState([]);
    const [selectedProject, setSelectedProject] = useState("all");

    const [searchQuery, setSearchQuery] = useState("");
    const [filterType, setFilterType] = useState("all");
    const [assignedFilter, setAssignedFilter] = useState("all");
    const statusFilter = null;
    const [uniqueEmployees, setUniqueEmployees] = useState([]);

    // Create Task modal states
    const [showCreateTask, setShowCreateTask] = useState(false);
    const [newTaskTitle, setNewTaskTitle] = useState("");
    const [newTaskDescription, setNewTaskDescription] = useState("");
    const [newTaskProject, setNewTaskProject] = useState("");
    const [newTaskAssignee, setNewTaskAssignee] = useState("");
    const [newTaskReporter, setNewTaskReporter] = useState("");
    const [newTaskDueDate, setNewTaskDueDate] = useState("");
    const [newTaskPriority, setNewTaskPriority] = useState("Medium");
    const [newTaskType, setNewTaskType] = useState("Feature");
    const [newTaskEstimatedTime, setNewTaskEstimatedTime] = useState("");
    const [newTaskTotalTime, setNewTaskTotalTime] = useState("");
    const [newTaskTeam, setNewTaskTeam] = useState("");
    const [teams, setTeams] = useState([]);
    const [editField, setEditField] = useState(null);
    const [editedTask, setEditedTask] = useState(activeTask);
    const [taskAttachments, setTaskAttachments] = useState([]);
    const [previewImages, setPreviewImages] = useState([]);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [projectEmployees, setProjectEmployees] = useState([]);
    const [collapsedProjects, setCollapsedProjects] = useState({});
    const loggedInEmployeeId = sessionStorage.getItem("employeeId");
    const [showLogForm, setShowLogForm] = useState(false);
    const [logDescription, setLogDescription] = useState("");
    const [logHours, setLogHours] = useState("");
    const [logDate, setLogDate] = useState(new Date().toISOString().split("T")[0]);
    const [billingType, setBillingType] = useState("billable");
    const [logAnother, setLogAnother] = useState(false);
    const [editWorklogId, setEditWorklogId] = useState(null);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [worklogs, setWorklogs] = useState([]);
    const [logHoursDecimal, setLogHoursDecimal] = useState(0); // numeric hours used when saving
    const [logHoursDisplay, setLogHoursDisplay] = useState(""); //  readable e.g. "1h 30m"
    const [logHoursRaw, setLogHoursRaw] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [editAttachments, setEditAttachments] = useState([]);
    const [replyShowSuggestions, setReplyShowSuggestions] = useState(false);
    const [replyAttachments, setReplyAttachments] = useState([]); // files for this inline reply
    const replyEditorRef = useRef(null);
    const [editingReplyId, setEditingReplyId] = useState(null);
    const [replyEditContent, setReplyEditContent] = useState("");
    const [replyEditAttachments, setReplyEditAttachments] = useState([]);
    const replyEditRef = useRef(null);
    const selectRef = useRef(null);
    const [newTaskParent, setNewTaskParent] = useState("");
    const [parentTasks, setParentTasks] = useState([]);

    // safe numeric values (in hours)
    const estimatedHrs = Number(activeTask?.estimatedTime ?? 0);
    const loggedHrs = worklogs.reduce((sum, w) => sum + Number(w.hours || 0), 0);

    const remainingHrs = Math.max(0, estimatedHrs - loggedHrs);
    const [timeStackOpen, setTimeStackOpen] = useState(false);
    // Sum of hours logged by all employees on the task
    const [taskTotalHrs, setTaskTotalHrs] = useState(null);


    const editorRef = useRef(null);
    const editRef = useRef(null);
    const navigate = useNavigate();
    const location = useLocation();
    const token = sessionStorage.getItem("token");
    const employeeId =
        location.state?.employeeId || sessionStorage.getItem("employeeId");

    const moveCaretToEnd = (el) => {
        if (!el) return;
        const range = document.createRange();
        range.selectNodeContents(el);
        range.collapse(false);
        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
    };

    const getStatusBadge = (status) => {
        switch (status) {
            case "PENDING":
                return "bg-secondary";
            case "IN_PROGRESS":
                return "bg-primary";
            case "REVIEW":
                return "bg-warning text-dark";
            case "COMPLETED":
                return "bg-success";
            default:
                return "bg-info";
        }
    };


    const resetCreateTaskForm = () => {
        setNewTaskTitle("");
        setNewTaskProject("");
        setNewTaskTeam("");
        setNewTaskType("Feature");
        setNewTaskDescription("");
        setNewTaskAssignee("");
        setNewTaskReporter("");
        setNewTaskParent("");
        setNewTaskDueDate("");
        setNewTaskPriority("Medium");
        setNewTaskEstimatedTime("");
    };


    useEffect(() => {
        setNewTaskParent(""); // reset parent when project changes
    }, [newTaskProject]);


    useEffect(() => {
        if (!activeTask?.id) return;

        const fetchAttachments = async () => {
            try {
                const res = await fetch(
                    `${API_BASE_URL}/api/tasks/${activeTask.id}/comment-attachments`,
                    {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    }
                );

                if (res.ok) {
                    const data = await res.json();
                    setTaskAttachments(data);
                } else {
                    console.error("Failed to fetch attachments:", res.status);
                }
            } catch (err) {
                console.error("Error fetching attachments:", err);
            }
        };

        fetchAttachments();
    }, [activeTask]);


    //fetch task by reporter
    useEffect(() => {
        if (!token || !employeeId) return;

        // Build URL with optional status filter
        let url = `${API_BASE_URL}/api/tasks/reported-by/${employeeId}`;
        if (statusFilter) {
            url += `?status=${statusFilter}`;
        }

        fetch(url, {
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((res) => res.json())
            .then((data) => {
                // ✅ Filter OUT parent tasks
                const filtered = Array.isArray(data)
                    ? data.filter(t => t.taskType !== "Parent")
                    : [];

                setTasks(filtered);
                setLoading(false);
            })
            .catch((err) => {
                console.error("Failed to fetch tasks:", err);
                setLoading(false);
            });
    }, [token, employeeId, statusFilter]);


    useEffect(() => {
        if (!employeeId || !token) {
            setLoading(false);
            return;
        }

        fetch(`${API_BASE_URL}/api/tasks/projects-of-employee/${employeeId}`, {
            headers: { Authorization: "Bearer " + token },
        })
            .then((res) => res.json())
            .then((data) => {

                if (!Array.isArray(data)) {
                    setTasks([]);
                    setParentTasks([]);
                    setLoading(false);
                    return;
                }

                // 🔥 Separate tasks based on taskType
                const childTasks = data.filter(t => t.taskType !== "Parent");
                const parentTaskList = data.filter(t => t.taskType === "Parent");

                // Update both states
                setTasks(childTasks);            // 🟢 normal tasks
                setParentTasks(parentTaskList);  // 🔵 parent tasks available

                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, [employeeId, token]);



    useEffect(() => {
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href =
            "https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css";
        link.id = "viewtasks-bootstrap";
        document.head.appendChild(link);

        return () => {
            const existingLink = document.getElementById("viewtasks-bootstrap");
            if (existingLink) existingLink.remove();
        };
    }, []);


    useEffect(() => {
        if (!token) return;

        const reporterId = sessionStorage.getItem("employeeId"); // reporter ID

        if (!reporterId) {
            console.error("Reporter/Employee ID missing");
            return;
        }

        fetch(`${API_BASE_URL}/api/manageteam/reporter/${reporterId}/projects`, {
            headers: { Authorization: "Bearer " + token },
        })
            .then((res) => {
                if (!res.ok) throw new Error("Failed to fetch reporter projects");
                return res.json();
            })
            .then((data) => setProjects(Array.isArray(data) ? data : []))
            .catch(() => setProjects([]));
    }, [token]);


    useEffect(() => {
        const fetchEmployees = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/api/employees/active`);
                if (response.ok) {
                    const data = await response.json();
                    setEmployees(data);
                } else {
                    console.error("Failed to fetch employees");
                }
            } catch (error) {
                console.error("Error fetching employees:", error);
            }
        };
        fetchEmployees();
    }, []);

    useEffect(() => {
  const token = sessionStorage.getItem("token");

  axios.get(
    `${API_BASE_URL}/api/teams`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )
    .then((res) => setTeams(res.data))
    .catch((err) => console.error("Error fetching teams:", err));
}, []);



    useEffect(() => {
        // If no project selected, clear dropdown options
        if (!newTaskProject) {
            setProjectEmployees([]);
            setNewTaskAssignee("");
            setNewTaskReporter("");
            return;
        }

        const fetchProjectEmployees = async () => {
            try {
                const res = await fetch(
                    `${API_BASE_URL}/api/manageteam/project/${newTaskProject}/employees`
                );
                if (!res.ok) {
                    console.error("Failed to load project employees");
                    setProjectEmployees([]);
                    return;
                }
                const data = await res.json();
                setProjectEmployees(data);

                // Reset selections if they are not in this project anymore
                setNewTaskAssignee("");
                setNewTaskReporter("");
            } catch (err) {
                console.error("Error fetching project employees", err);
                setProjectEmployees([]);
            }
        };

        fetchProjectEmployees();
    }, [newTaskProject]);


    const startEditStatus = (task) => {
        setEditedTask({ ...task }); // shallow copy so we edit locally
        setEditField("status");
    };

    // use this to cancel/finish editing
    const finishEditStatus = () => {
        setEditField(null);
        setEditedTask(null);
    };


    // --- Add this near your persist/clear helpers (inside the component) ---
    const restorePersistedTask = async () => {
        try {
            const storedId = localStorage.getItem(ACTIVE_TASK_KEY);
            const storedObj = localStorage.getItem(ACTIVE_TASK_DATA_KEY);
            if (!storedId) return;

            // If we have the full object stored, restore it immediately
            if (storedObj) {
                try {
                    const parsed = JSON.parse(storedObj);
                    setActiveTask(parsed);
                    // kick off fetches for comments/worklogs to populate modal details
                    fetch(`${API_BASE_URL}/api/tasks/${parsed.id}/comments`, {
                        headers: { Authorization: "Bearer " + token },
                    })
                        .then((res) => res.json())
                        .then((data) => setComments(Array.isArray(data) ? data : []))
                        .catch(() => setComments([]));

                    fetchWorklogs(parsed.id);
                    return;
                } catch (err) {
                    // fallthrough to fetch by id if parse fails
                    console.warn("Failed to parse persisted task object, will fetch by id", err);
                }
            }

            // Otherwise fetch task by id to get fresh data
            const id = Number(storedId);
            if (!id) return;

            const res = await fetch(`${API_BASE_URL}/api/tasks/${id}`, {
                headers: { Authorization: "Bearer " + token },
            });
            if (res.ok) {
                const task = await res.json();
                setActiveTask(task);
                // fetch comments & worklogs
                fetch(`${API_BASE_URL}/api/tasks/${id}/comments`, {
                    headers: { Authorization: "Bearer " + token },
                })
                    .then((r) => r.json())
                    .then((data) => setComments(Array.isArray(data) ? data : []))
                    .catch(() => setComments([]));

                fetchWorklogs(id);
            } else {
                // if task cannot be fetched, clear persisted state
                clearPersistedTask();
            }
        } catch (err) {
            console.error("Error restoring persisted task:", err);
        }
    };

    useEffect(() => {
        // run once on mount to restore the modal if previously open
        restorePersistedTask();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    // Call this to close the modal (e.g. hook it up to Close button)
    const closeModal = () => {
        clearPersistedTask();
        setActiveTask(null);
        setComments([]);
        // any other cleanup if required
    };


    const fetchTaskTotalLogs = async (taskId) => {
        if (!taskId) {
            setTaskTotalHrs(null);
            return;
        }

        try {
            const res = await fetch(`${API_BASE_URL}/api/worklogs/task/${taskId}`, {
                headers: { Authorization: "Bearer " + token },
            });

            if (!res.ok) {
                // Endpoint missing or not allowed — fallback to per-employee worklogs sum
                throw new Error(`Failed to fetch all worklogs: ${res.status}`);
            }

            const data = await res.json();
            // Expecting an array of worklog objects with numeric `hours` property
            const total = (data || []).reduce((sum, w) => sum + Number(w.hours || 0), 0);
            setTaskTotalHrs(Number(total.toFixed(2)));
        } catch (err) {
            // fallback: sum whatever we already have in `worklogs` (likely current employee only)
            console.warn("fetchTaskTotalLogs fallback to local worklogs:", err);
            const fallback = (worklogs || []).reduce((s, w) => s + Number(w.hours || 0), 0);
            setTaskTotalHrs(Number(fallback.toFixed(2)));
        }
    };

    useEffect(() => {
        if (!showCreateTask) return;

        // If user opened create modal and a sidebar project is active, prefill it
        if (selectedProject && selectedProject !== "all") {
            setNewTaskProject(String(selectedProject));
        } else {
            setNewTaskProject(""); // keeps modal blank if no project selected
        }
        // focus or additional initialization can go here
    }, [showCreateTask, selectedProject]);


    // useEffect(() => {
    //     if (!employeeId || !token) return;
    //     fetch(
    //         `${API_BASE_URL}/api/tasks/mentionable-users?employeeId=${employeeId}`,
    //         { headers: { Authorization: "Bearer " + token } }
    //     )
    //         .then((res) => res.json())
    //         .then((data) => setMentionableUsers(data))
    //         .catch(() => setMentionableUsers([]));
    // }, [employeeId, token]);

    useEffect(() => {
        // Need an active task AND its project
        if (!activeTask || !activeTask.project || !activeTask.project.id) {
            setMentionableUsers([]);
            return;
        }

        const projectId = activeTask.project.id;

        const fetchMentionableUsers = async () => {
            try {
                const response = await fetch(
                    `${API_BASE_URL}/api/manageteam/project/${projectId}/employees`
                );

                if (response.ok) {
                    const data = await response.json();
                    setMentionableUsers(Array.isArray(data) ? data : []);
                } else {
                    console.error("Failed to fetch project employees for mentions");
                    setMentionableUsers([]);
                }
            } catch (error) {
                console.error("Error fetching mention users:", error);
                setMentionableUsers([]);
            }
        };

        fetchMentionableUsers();
    }, [activeTask]);



    useEffect(() => {
        if (!token || !employeeId) return;

        fetch(`${API_BASE_URL}/api/manageteam/reporter/${employeeId}`, {
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(res => res.json())
            .then(data => {
                // Normalize as array
                const arr = Array.isArray(data) ? data : (data ? [data] : []);

                // Collect all candidate people: item.employee and item.reporter (if present)
                const candidates = [];
                arr.forEach(item => {
                    if (!item) return;
                    if (item.employee) candidates.push(item.employee);
                    // handle possible shapes: item.reporter OR item.reporter.employee
                    if (item.reporter) {
                        // reporter might be nested (e.g. { reporter: { employee: {...} } })
                        const rep = item.reporter.employee ? item.reporter.employee : item.reporter;
                        if (rep) candidates.push(rep);
                    }
                });

                // Deduplicate by id
                const seen = new Set();
                const uniqueEmployees = candidates.filter(emp => {
                    if (!emp || !emp.id) return false;
                    if (seen.has(emp.id)) return false;
                    seen.add(emp.id);
                    return true;
                });

                // Convert to unique names (fallback to single name if lastName missing)
                const names = uniqueEmployees.map(emp => {
                    const first = emp.firstName || emp.first_name || "";
                    const last = emp.lastName || emp.last_name || "";
                    const full = `${first} ${last}`.trim();
                    return full || emp.name || `#${emp.id}`;
                });

                setUniqueEmployees(names);
            })
            .catch(err => console.error("Failed to fetch employees:", err));
    }, [token, employeeId]);


    const employeeIdFromSession = Number(sessionStorage.getItem("employeeId"));
    const currentEmp = employees.find(e => Number(e.id) === employeeIdFromSession);
    const loggedUserName = currentEmp ? `${currentEmp.firstName} ${currentEmp.lastName}`.trim() : "";


    async function handleReplyPaste(e) {
        try {
            if (!e.clipboardData) return;
            const items = Array.from(e.clipboardData.items || []);
            // look for image items first
            const imageItem = items.find(it => it.type && it.type.startsWith("image/"));

            if (!imageItem) {
                // no image — allow default paste (text/HTML)
                return;
            }

            // prevent default so the browser doesn't insert a raw image blob URL
            e.preventDefault();

            // get blob
            const blob = imageItem.getAsFile();
            if (!blob) return;

            // optional: give it a filename
            const filename = `pasted-${Date.now()}.png`;

            // convert to base64 data URL (so you can preview inline)
            const toBase64 = (b) =>
                new Promise((res, rej) => {
                    const reader = new FileReader();
                    reader.onload = () => res(reader.result);
                    reader.onerror = rej;
                    reader.readAsDataURL(b);
                });

            const dataUrl = await toBase64(blob); // "data:image/png;base64,...."

            // 1) insert an <img> at caret position inside the contentEditable
            insertImageAtCaret(dataUrl);

            // 2) add to replyAttachments state so it can be uploaded with the reply
            // store both the original blob (file) and a preview base64 so UI can show it
            const fileObj = { name: filename, file: blob, base64: dataUrl };
            if (typeof setReplyAttachments === "function") {
                setReplyAttachments((prev) => [...(prev || []), fileObj]);
            }

            // update UI state / placeholder / suggestion logic
            if (typeof handleReplyEditorInput === "function") handleReplyEditorInput();

        } catch (err) {
            console.error("handleReplyPaste error:", err);
        }
    }

    function insertImageAtCaret(dataUrl) {
        const el = replyEditorRef.current;
        if (!el) return;

        // create image node
        const img = document.createElement("img");
        img.src = dataUrl;
        img.alt = "pasted-image";
        img.style.maxWidth = "180px";
        img.style.maxHeight = "120px";
        img.style.borderRadius = "8px";
        img.style.display = "block";
        img.style.margin = "6px 0";

        // insert at caret / selection
        const sel = window.getSelection();
        if (!sel || !sel.rangeCount) {
            el.appendChild(img);
        } else {
            const range = sel.getRangeAt(0);
            // place the image at the caret, replacing any selected range
            range.deleteContents();
            range.insertNode(img);

            // move caret after the inserted image
            range.setStartAfter(img);
            range.collapse(true);
            sel.removeAllRanges();
            sel.addRange(range);
        }

        // focus editor
        el.focus();
    }

    function insertMentionAtCaret(user) {
        const el = replyEditorRef.current;
        if (!el) return;

        const text = el.innerText || "";
        const lastAt = text.lastIndexOf("@");
        const mention = `@${user.firstName} ${user.lastName} `;

        // find caret position
        let caretPos = text.length;
        const sel = window.getSelection();
        if (sel && sel.rangeCount) {
            const range = sel.getRangeAt(0).cloneRange();
            range.selectNodeContents(el);
            range.setEnd(sel.getRangeAt(0).endContainer, sel.getRangeAt(0).endOffset);
            caretPos = range.toString().length;
        }

        // if there's no '@' before the caret, just insert at caret
        if (lastAt === -1 || lastAt > caretPos) {
            document.execCommand("insertText", false, mention);
            handleReplyEditorInput();
            if (typeof setReplyShowSuggestions === "function") setReplyShowSuggestions(false);
            return;
        }

        // replace from lastAt up to caretPos with mention
        const before = text.slice(0, lastAt);
        const after = text.slice(caretPos);
        const newText = before + mention + after;

        // set plain text and move caret after inserted mention
        el.innerText = newText;

        // position caret right after the inserted mention
        const node = el.firstChild || el;
        const pos = (before + mention).length;
        const newRange = document.createRange();
        try {
            newRange.setStart(node, Math.min(pos, node.length || pos));
            newRange.collapse(true);
            const s = window.getSelection();
            s.removeAllRanges();
            s.addRange(newRange);
        } catch (err) {
            // fallback: focus at end
            el.focus();
            document.execCommand("selectAll");
            document.getSelection().collapseToEnd();
        }

        // update UI / hide suggestions
        handleReplyEditorInput();
        if (typeof setReplyShowSuggestions === "function") setReplyShowSuggestions(false);
    }

    // Parse attachments field from reply (handles JSON-string or array)
    const parseAttachmentsField = (reply) => {
        try {
            let arr = reply.attachments;
            if (!arr) return [];
            if (typeof arr === "string") {
                try {
                    arr = JSON.parse(arr);
                } catch (e) {
                    // sometimes server wraps JSON with extra quotes; try to salvage
                    const trimmed = arr.trim();
                    if (trimmed.startsWith('"[') && trimmed.endsWith(']"')) {
                        try { arr = JSON.parse(JSON.parse(trimmed)); } catch (ee) { return []; }
                    } else return [];
                }
            }
            if (!Array.isArray(arr)) return [];

            return arr.map((a) => {
                const name = a.name || a.originalName || "attachment";
                const href = ensureDataUrl(a) || a.path || a.url || null;
                const isImage =
                    (a.type && typeof a.type === "string" && a.type.startsWith("image")) ||
                    (href && typeof href === "string" && href.startsWith("data:image")) ||
                    /\.(jpe?g|png|gif|bmp|webp|svg)$/i.test(name);
                return { name, href, isImage };
            });
        } catch (err) {
            console.error("parseAttachmentsField error:", err);
            return [];
        }
    };

    // Ensure we produce a usable href for attachments
    const ensureDataUrl = (att) => {
        if (!att) return null;
        if (att.base64 && typeof att.base64 === "string") {
            // if base64 is already a full data: URL, return as-is
            if (att.base64.startsWith("data:")) return att.base64;
            // otherwise build one using provided type or guessed mime
            const mime = att.type || getMimeType(att.name || "");
            return `data:${mime};base64,${att.base64}`;
        }
        // server might return path/url fields
        if (att.path || att.url) return att.path || att.url;
        return null;
    };

    const cancelEditReply = () => {
        setEditingReplyId(null);
        setReplyEditContent("");
        setReplyEditAttachments([]);
        if (replyEditRef.current) replyEditRef.current.innerHTML = "";
    };

    const saveReplyEdit = async (replyId, parentCommentId) => {
        // read plain text and html
        const html = replyEditRef.current?.innerHTML || replyEditContent || "";
        const text = (replyEditRef.current?.innerText || replyEditContent || "").trim();

        // if both empty and no attachments, ignore
        if (!text && (!replyEditAttachments || replyEditAttachments.length === 0)) return;

        const token = sessionStorage.getItem("token");

        // prepare attachments payload
        const newAttachments = await convertFilesToPayload(replyEditAttachments);

        const body = {
            text,
            html,
            // For compatibility: server expects attachments array or attachments JSON string.
            attachments: newAttachments,
        };

        try {
            // try reasonable endpoint — adjust if your backend uses different route
            const res = await fetch(`${API_BASE_URL}/api/tasks/comments/replies/${replyId}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token,
                },
                body: JSON.stringify(body),
            });

            if (!res.ok) {
                // fallback: try alternate endpoint
                const alt = await fetch(`${API_BASE_URL}/api/tasks/comments/${parentCommentId}/replies/${replyId}`, {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + token,
                    },
                    body: JSON.stringify(body),
                });
                if (!alt.ok) {
                    console.error("Failed to save reply edit:", await alt.text());
                    return;
                }
                const updatedAlt = await alt.json();
                // update UI below with updatedAlt
                updateReplyInComments(updatedAlt, parentCommentId);
            } else {
                const updated = await res.json();
                updateReplyInComments(updated, parentCommentId);
            }

            // cleanup
            cancelEditReply();
        } catch (err) {
            console.error("saveReplyEdit error:", err);
        }
    };

    const updateReplyInComments = (updatedReply, parentCommentId) => {
        setComments(prevComments =>
            prevComments.map(c => {
                if (c.id !== parentCommentId) return c;
                const newReplies = (c.replies || []).map(r => (r.id === updatedReply.id ? updatedReply : r));
                return { ...c, replies: newReplies };
            })
        );
    };

    const deleteReply = async (replyId, parentCommentId) => {
        if (!window.confirm("Are you sure you want to delete this reply?")) return;
        const token = sessionStorage.getItem("token");
        try {
            // try endpoint 1
            let res = await fetch(`${API_BASE_URL}/api/tasks/comments/replies/${replyId}`, {
                method: "DELETE",
                headers: { Authorization: "Bearer " + token },
            });

            if (!res.ok) {
                // try alternate
                res = await fetch(`${API_BASE_URL}/api/tasks/comments/${parentCommentId}/replies/${replyId}`, {
                    method: "DELETE",
                    headers: { Authorization: "Bearer " + token },
                });
            }

            if (!res.ok) {
                console.error("Failed to delete reply:", await res.text());
                return;
            }

            // remove from comments state
            setComments(prev => prev.map(c => c.id === parentCommentId ? { ...c, replies: (c.replies || []).filter(r => r.id !== replyId) } : c));
        } catch (err) {
            console.error("deleteReply error:", err);
        }
    };

    const convertFilesToPayload = async (attachmentsArr) => {
        const out = [];
        for (const a of attachmentsArr || []) {
            // if already base64 or url or id keep as-is
            if (a.base64 && typeof a.base64 === "string") {
                out.push({ name: a.name, base64: a.base64 });
                continue;
            }
            if (a.file instanceof File) {
                try {
                    const b64 = await fileToBase64(a.file); // fileToBase64 returns dataURL in your file
                    out.push({ name: a.name || a.file.name, base64: b64 });
                } catch (err) {
                    console.warn("Failed to convert reply edit file to base64", err);
                }
                continue;
            }
            // keep url/id as metadata so server can keep reference
            if (a.url || a.id) out.push({ name: a.name, url: a.url, id: a.id });
        }
        return out;
    };

    function handleReplyEditorInput(e) {
        try {
            const el = replyEditorRef.current;
            if (!el) return;

            const text = el.innerText || "";
            const trimmed = text.trim();

            // placeholder hide
            el.setAttribute("data-filled", trimmed.length > 0 ? "true" : "false");

            // update reply content
            setReplyContent(text);

            // --- MENTION TRIGGER LOGIC ---
            // find last "@"
            const cursorText = text;
            const lastAt = cursorText.lastIndexOf("@");

            // No @ → hide
            if (lastAt === -1) {
                setReplyShowSuggestions(false);
                return;
            }

            // Get text typed after the '@'
            const after = cursorText.slice(lastAt + 1);

            // If user typed a space or pressed enter → hide
            if (after.includes(" ") || after.includes("\n")) {
                setReplyShowSuggestions(false);
                return;
            }

            // Now show suggestions (user is typing after '@')
            setReplyShowSuggestions(true);

            // Filter users
            const lower = after.toLowerCase();
            const list = mentionableUsers.filter(u =>
                (`${u.firstName} ${u.lastName}`).toLowerCase().includes(lower)
            );
            setFilteredUsers(list);

        } catch (err) {
            console.error("handleReplyEditorInput error:", err);
        }
    }

    function handleCommentImageClick(e, comment) {
        // if the click landed on an <img> (or inside an anchor that wraps an <img>), find the actual <img>
        let target = e.target;
        if (!target) return;

        // if link wrapped the image, prefer the <img> child
        if (target.tagName === "A") {
            const imgChild = target.querySelector("img");
            if (imgChild) target = imgChild;
        }

        if (target.tagName !== "IMG") return; // ignore non-image clicks

        // Prevent other click handlers (like collapse toggles) from firing
        e.stopPropagation();

        // current comment DOM node (the container where you set innerHTML)
        const container = e.currentTarget; // safe: this is the comment-body DOM element

        // collect all images inside this comment in document order
        const imgs = Array.from(container.querySelectorAll("img")).map((img) => img.src).filter(Boolean);

        if (!imgs.length) return;

        // determine the index of the clicked image
        const clickedSrc = target.src;
        const idx = imgs.indexOf(clickedSrc);
        const realIndex = idx === -1 ? 0 : idx;

        // open your existing preview state
        setPreviewImages(imgs);
        setCurrentImageIndex(realIndex);
    }

    // insert mention helper (places mention at caret inside editRef)
    function insertMentionAtCaretInEdit(user) {
        const el = editRef.current;
        if (!el) return;

        const sel = window.getSelection();
        if (!sel || sel.rangeCount === 0) return;
        const range = sel.getRangeAt(0);

        // Helper: find text-node and offset inside the container for a given global text offset
        function nodeForOffset(root, offset) {
            const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
            let node;
            let idx = 0;
            while ((node = walker.nextNode())) {
                const len = node.textContent.length;
                if (offset <= idx + len) {
                    return { node, offsetInNode: Math.max(0, offset - idx) };
                }
                idx += len;
            }
            // fallback: return last text node
            return { node: root, offsetInNode: root.textContent.length };
        }

        // Build a Range that covers from start of editor to caret to find the last '@'
        const beforeRange = range.cloneRange();
        beforeRange.selectNodeContents(el);
        beforeRange.setEnd(range.endContainer, range.endOffset);
        const beforeText = beforeRange.toString();
        const atIndex = beforeText.lastIndexOf("@");

        // If no @ present, just insert mention at caret (with @)
        // const mentionLabel = `@${user.firstName}${user.lastName ? " " + user.lastName : ""}`;
        const mentionLabel = `${user.firstName}${user.lastName ? " " + user.lastName : ""}`;
        if (atIndex === -1) {
            // insert simple mention node at caret
            const mentionNode = document.createElement("span");
            mentionNode.setAttribute("data-mention-id", String(user.id || ""));
            mentionNode.setAttribute("contenteditable", "false"); // optional: makes it a unit
            mentionNode.className = "mention-chip"; // style as you like
            mentionNode.textContent = mentionLabel;

            // Insert and add a trailing space
            const trailing = document.createTextNode(" ");

            // Insert into range
            range.deleteContents();
            range.insertNode(trailing);
            range.insertNode(mentionNode);

            // Move caret after the trailing space
            const newRange = document.createRange();
            newRange.setStartAfter(trailing);
            newRange.collapse(true);
            sel.removeAllRanges();
            sel.addRange(newRange);

            setEditContent(el.innerHTML || "");
            setReplyShowSuggestions(false);
            el.focus();
            return;
        }

        // We have an '@' somewhere before caret. We want to replace only the text AFTER '@' up to caret,
        // but keep the '@' character itself. So start replace range at atIndex + 1 (right after '@').
        const startInfo = nodeForOffset(el, atIndex + 1); // start after @
        const endInfo = nodeForOffset(el, beforeText.length);

        if (!startInfo.node || !endInfo.node) {
            // fallback: insert at caret normally
            document.execCommand("insertText", false, mentionLabel + " ");
            setEditContent(el.innerHTML || "");
            setReplyShowSuggestions(false);
            el.focus();
            return;
        }

        // Build a DOM Range from startInfo to endInfo (this covers the typed fragment after @)
        const replaceRange = document.createRange();
        try {
            replaceRange.setStart(startInfo.node, startInfo.offsetInNode);
            replaceRange.setEnd(endInfo.node, endInfo.offsetInNode);
        } catch (err) {
            // fall back to simple insertion
            document.execCommand("insertText", false, mentionLabel + " ");
            setEditContent(el.innerHTML || "");
            setReplyShowSuggestions(false);
            el.focus();
            return;
        }

        // Delete the typed fragment (keeps the '@' char)
        replaceRange.deleteContents();

        // Create mention element (keeps @ visually — we prefix with @)
        const mentionSpan = document.createElement("span");
        mentionSpan.setAttribute("data-mention-id", String(user.id || ""));
        mentionSpan.setAttribute("contenteditable", "false"); // optional — makes it atomic
        mentionSpan.className = "mention-chip";
        mentionSpan.textContent = mentionLabel;

        // Insert mention and a trailing space
        const spaceNode = document.createTextNode(" ");
        replaceRange.insertNode(spaceNode);
        replaceRange.insertNode(mentionSpan);

        // Put caret after the trailing space
        const afterRange = document.createRange();
        afterRange.setStartAfter(spaceNode);
        afterRange.collapse(true);
        sel.removeAllRanges();
        sel.addRange(afterRange);

        // update state + hide suggestions
        setEditContent(el.innerHTML || "");
        setReplyShowSuggestions(false);
        el.focus();
    }

    // handle paste (keeps images & strips bad formatting — adapt to your app)
    async function handleEditPaste(e) {
        if (!e) return;
        e.preventDefault();
        const clipboard = e.clipboardData || window.clipboardData;
        if (!clipboard) return;

        // helpers (use your existing saveCaret / moveCaretToEnd if present)
        function insertHtmlAtCaret(html) {
            const sel = window.getSelection();
            if (!sel || !sel.rangeCount) {
                if (editRef.current) editRef.current.insertAdjacentHTML("beforeend", html);
                return;
            }
            const range = sel.getRangeAt(0);
            range.deleteContents();

            const el = document.createElement("div");
            el.innerHTML = html;
            const frag = document.createDocumentFragment();
            let node;
            while ((node = el.firstChild)) frag.appendChild(node);

            range.insertNode(frag);
            // place caret after inserted nodes
            range.collapse(false);
            sel.removeAllRanges();
            sel.addRange(range);
            if (typeof saveCaret === "function") saveCaret();
        }

        // 1) If files are present in clipboard (images), read and insert them
        const items = Array.from(clipboard.items || []);
        const fileItems = items.filter(it => it.kind === "file" && it.type && it.type.startsWith("image/"));

        if (fileItems.length) {
            // process each file item sequentially so insertion order is preserved
            for (const it of fileItems) {
                const file = it.getAsFile();
                if (!file) continue;

                // convert file -> base64
                const base64 = await new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = reject;
                    reader.readAsDataURL(file);
                }).catch((err) => {
                    console.warn("Failed to read pasted file", err);
                    return null;
                });

                if (!base64) continue;

                // Insert image into editor at caret
                const imgHtml = `<img src="${base64}" alt="${file.name}" style="max-width:50%;height:auto;display:block;margin:6px 0;" />`;
                insertHtmlAtCaret(imgHtml);

                // add to attachments so saveEdit will send it
                setEditAttachments(prev => [...(prev || []), { name: file.name, file, base64 }]);

                // small delay for large images to ensure DOM updates before caret move
                await new Promise((r) => setTimeout(r, 10));
            }

            // update editContent to reflect new HTML
            if (editRef.current) {
                setEditContent(editRef.current.innerHTML || "");
                // mark as filled
                editRef.current.setAttribute("data-filled", "true");
                moveCaretToEnd(editRef.current);
            }
            return;
        }

        // 2) If clipboard has rich HTML, insert it (preserve formatting & inline images)
        const htmlData = clipboard.getData && clipboard.getData("text/html");
        if (htmlData && htmlData.trim()) {
            insertHtmlAtCaret(htmlData);
            if (editRef.current) {
                setEditContent(editRef.current.innerHTML || "");
                editRef.current.setAttribute("data-filled", "true");
                moveCaretToEnd(editRef.current);
            }
            return;
        }

        // 3) Fallback: plain text (preserve newlines)
        const text = clipboard.getData && clipboard.getData("text/plain");
        if (text) {
            const escaped = text
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/\r\n|\r|\n/g, "<br/>");
            insertHtmlAtCaret(escaped);
            if (editRef.current) {
                setEditContent(editRef.current.innerHTML || "");
                editRef.current.setAttribute("data-filled", "true");
                moveCaretToEnd(editRef.current);
            }
            return;
        }
    }


    const deleteWorklog = async (worklogId) => {
        if (!window.confirm("Are you sure you want to delete this worklog?")) return;
        try {
            const res = await fetch(`${API_BASE_URL}/api/worklogs/${worklogId}`, {
                method: "DELETE",
                headers: { Authorization: "Bearer " + token },
            });
            if (res.ok) {
                setWorklogs((prev) => prev.filter((w) => w.id !== worklogId));
            } else {
                console.error("Failed to delete worklog");
            }
        } catch (err) {
            console.error("Error deleting worklog:", err);
        }
    };

    // Convert various stored values into decimal hours
    const ensureDecimalHours = (value) => {
        if (value == null) return 0;
        // If it's an object or string like "1.5" or "90" or "90m" or "1:30"
        if (typeof value === "string") {
            const s = value.trim().toLowerCase();
            if (s.endsWith("m")) {
                // "90m" -> minutes
                const n = Number(s.replace("m", ""));
                return Number((n / 60).toFixed(2));
            }
            if (s.includes("h") || s.includes("m")) {
                // parse "1h 30m"
                const hourMatch = s.match(/(\d+(?:\.\d+)?)\s*h/);
                const minuteMatch = s.match(/(\d+(?:\.\d+)?)\s*m/);
                const hours = hourMatch ? parseFloat(hourMatch[1]) : 0;
                const minutes = minuteMatch ? parseFloat(minuteMatch[1]) : 0;
                return Number((hours + minutes / 60).toFixed(2));
            }
            if (s.includes(":")) {
                // "1:30" -> hours:minutes
                const [hStr, mStr] = s.split(":");
                const h = Number(hStr || 0);
                const m = Number(mStr || 0);
                return Number((h + m / 60).toFixed(2));
            }
            // otherwise numeric string
            const n = Number(s.replace(",", "."));
            if (!Number.isNaN(n)) {
                // Heuristic: if n > 24 treat as minutes
                if (n > 24) return Number((n / 60).toFixed(2));
                return Number(n.toFixed(2));
            }
            return 0;
        }

        // numeric input
        if (typeof value === "number") {
            // heuristic: if value > 24 -> minutes stored, convert
            if (value > 24) return Number((value / 60).toFixed(2));
            return Number(value.toFixed(2));
        }

        return 0;
    };

    const editWorklog = (log) => {
        setShowLogForm(true);
        setEditWorklogId(log.id);

        // description
        setLogDescription(log.description ?? log.notes ?? "");

        // billing type
        setBillingType(log.billingType ?? "billable");

        // date normalization: accept "YYYY-MM-DD" or ISO timestamp
        let normalizedDate = "";
        if (log.date) {
            normalizedDate = String(log.date).includes("T") ? String(log.date).split("T")[0] : String(log.date);
        } else if (log.loggedAt) {
            normalizedDate = String(log.loggedAt).includes("T") ? String(log.loggedAt).split("T")[0] : String(log.loggedAt);
        }
        setLogDate(normalizedDate || new Date().toISOString().split("T")[0]);

        // Hours: convert whatever the API returns into decimal + readable + raw states
        const decimal = ensureDecimalHours(log.hours ?? log.duration ?? log.minutes ?? log.time ?? log.loggedHours ?? 0);
        const readable = formatDecimalToReadable(decimal);

        // Set numeric hours for backend
        if (typeof setLogHoursDecimal === "function") setLogHoursDecimal(decimal);

        // Set what the input shows (we use readable as requested)
        if (typeof setLogHoursRaw === "function") setLogHoursRaw(readable);
        if (typeof setLogHoursDisplay === "function") setLogHoursDisplay(readable);

        // Backwards compatibility: if you still use `logHours` state anywhere, set it too
        if (typeof setLogHours === "function") setLogHours(readable);
    };

    const formatH = (hours) => {
        if (!hours || isNaN(hours)) return "0m";

        const h = Math.floor(hours);
        const m = Math.round((hours - h) * 60);

        if (h > 0 && m > 0) return `${h}h ${m}m`;
        if (h > 0) return `${h}h`;
        if (m > 0) return `${m}m`;
        return "0m";
    };

    // Save a new worklog
    const saveWorklog = async () => {
        try {
            console.log("saveWorklog() called", {
                activeTask,
                logDescription,
                // include all possible duration vars so we can see what's present
                logHours,         // if you used older name
                logHoursRaw,      // if you used raw editing name
                logHoursDisplay,  // readable shown after blur
                logHoursDecimal,  // numeric value used for backend
                billingType,
                logDate,
                editWorklogId,
            });

            // Ensure we have a task
            if (!activeTask?.id) {
                alert("No task selected.");
                return;
            }

            // Use numeric decimal hours (fall back to parsing other fields if needed)
            const hours = typeof logHoursDecimal === "number" && logHoursDecimal > 0
                ? logHoursDecimal
                : // fallback: if you still have logHours (a numeric-like string)
                (logHours ? Number(String(logHours).replace(",", ".")) : 0);

            if (!hours || Number.isNaN(hours) || hours <= 0) {
                alert("Please enter a valid duration (e.g. 0.5 or 30m).");
                return;
            }

            // Validate description
            if (!logDescription || !String(logDescription).trim()) {
                alert("Please enter a description.");
                return;
            }

            // Ensure date
            if (!logDate) {
                alert("Please select a date.");
                return;
            }

            // Ensure token and employeeId exist (try sessionStorage fallback)
            const tokenLocal = typeof token !== "undefined" && token ? token : sessionStorage.getItem("token");
            const employeeIdLocal = typeof employeeId !== "undefined" && employeeId ? employeeId : sessionStorage.getItem("employeeId");

            if (!employeeIdLocal) {
                console.warn("employeeId not available in scope; using sessionStorage fallback", employeeIdLocal);
            }

            const payload = {
                employeeId: Number(employeeIdLocal || 0),
                taskId: Number(activeTask.id),
                description: String(logDescription).trim(),
                hours: Number(hours),
                billingType: billingType || "non-billable",
                date: logDate, // expected YYYY-MM-DD
                taskCode: activeTask.taskCode,
            };

            console.log("Worklog payload:", payload);

            // Call API
            let res;
            const headers = {
                "Content-Type": "application/json",
                ...(tokenLocal && { Authorization: "Bearer " + tokenLocal }),
            };

            if (editWorklogId) {
                res = await fetch(`${API_BASE_URL}/api/worklogs/${editWorklogId}`, {
                    method: "PUT",
                    headers,
                    body: JSON.stringify(payload),
                });
            } else {
                res = await fetch(`${API_BASE_URL}/api/worklogs`, {
                    method: "POST",
                    headers,
                    body: JSON.stringify(payload),
                });
            }

            if (!res.ok) {
                const txt = await res.text();
                console.error("saveWorklog failed:", txt);
                alert("Failed to save worklog: " + txt);
                return;
            }

            const updatedLog = await res.json();
            console.log("saveWorklog success:", updatedLog);
            fetchTaskTotalLogs(activeTask.id);
            fetchWorklogs(activeTask.id);

            setWorklogs((prev) => {
                if (editWorklogId) {
                    setWorklogs(prev => editWorklogId ? prev.map(w => (w.id === editWorklogId ? updatedLog : w)) : [updatedLog, ...(prev || [])]);

                } else {
                    return [...prev, updatedLog];
                }
            });

            // Reset form: clear whichever duration fields you use in your component
            setEditWorklogId(null);
            setLogDescription("");
            // If you used the raw/display split:
            if (typeof setLogHoursRaw === "function") {
                setLogHoursRaw("");
            }
            if (typeof setLogHoursDisplay === "function") {
                setLogHoursDisplay("");
            }
            // If you used single logHours state:
            if (typeof setLogHours === "function") {
                setLogHours("");
            }
            if (typeof setLogHoursDecimal === "function") {
                setLogHoursDecimal(0);
            }

            setBillingType("billable");
            // Set default date to today if you prefer:
            setLogDate(new Date().toISOString().split("T")[0]);

            if (!logAnother) {
                setShowLogForm(false);
            } else {
                // keep modal open, but clear for next entry
                // leave date as-is (or keep today's date)
            }
        } catch (err) {
            console.error("Error saving worklog:", err);
            alert("Error saving worklog — see console for details.");
        }
    };

    const filteredLogs = worklogs.filter(log => {
        if (filterType === "date") {
            if (!fromDate || !toDate) return false;
            const logDate = new Date(log.date);
            const start = new Date(fromDate);
            const end = new Date(toDate);
            return logDate >= start && logDate <= end;
        }
        return true;
    });

    // --- helpers (add to component) ---
    const formatDecimalToReadable = (decimal) => {
        if (!decimal || isNaN(decimal) || decimal <= 0) return "";
        const hours = Math.floor(decimal);
        const minutes = Math.round((decimal - hours) * 60);
        const parts = [];
        if (hours > 0) parts.push(`${hours}h`);
        if (minutes > 0) parts.push(`${minutes}m`);
        return parts.join(" ") || "0m";
    };


    const handleDurationBlur = () => {
        const dec = parseDurationToDecimal(logHoursRaw);

        if (dec > 24) {
            return; // do nothing; keep user text so they correct it
        }

        setLogHoursDecimal(dec);

        const readable = formatDecimalToReadable(dec);
        setLogHoursDisplay(readable);
        setLogHoursRaw(readable);
    };



    // Optional: when focusing back into the input, show the raw decimal or allow editing
    const handleDurationFocus = () => {
        // Let user edit the previous raw value. If display contains readable like "1h 30m",
        // we'll set raw to decimal string to make editing easier (optional).
        // Here we set raw to decimal string to allow quick edits like 1.5 -> back to 1.5
        if (logHoursDisplay) {
            // keep decimal with up to 2 decimals
            setLogHoursRaw(logHoursDecimal > 0 ? String(logHoursDecimal) : "");
        }
    };

    const applyLocalTaskUpdate = (updates) => {
        if (typeof setActiveTask === "function") {
            setActiveTask((prev) => (prev ? { ...prev, ...updates } : prev));
        }
    };

    const parseDurationToDecimal = (input) => {
        if (!input) return 0;
        const s = String(input).trim().toLowerCase();

        // human format with h/m
        if (/[hm]/.test(s)) {
            const hourMatch = s.match(/(\d+(?:\.\d+)?)\s*h/);
            const minuteMatch = s.match(/(\d+(?:\.\d+)?)\s*m/);

            const hours = hourMatch ? parseFloat(hourMatch[1]) : 0;
            const minutes = minuteMatch ? parseFloat(minuteMatch[1]) : 0;

            // If user entered only minutes like "90m" that yields hours + minutes/60
            return Number((hours + minutes / 60).toFixed(2));
        }

        // treat as decimal number (accept comma as decimal separator)
        const normalized = s.replace(",", ".");
        const num = Number(normalized);
        return !isNaN(num) ? Number(num.toFixed(2)) : 0;
    };

    const handleDurationChange = (raw) => {
        setLogHoursRaw(raw);

        // parse full duration into hours
        const dec = parseDurationToDecimal(raw);

        // allow minutes-only inputs like "50m"
        // allow any text UNTIL it becomes > 24h
        if (dec > 24) {
            return;  // block further typing
        }

        setLogHoursDecimal(dec);
    };

    const ACTIVE_TASK_KEY = "activeTaskId";
    const ACTIVE_TASK_DATA_KEY = "activeTaskObj";

    // Save active task to localStorage
    function persistActiveTask(task) {
        try {
            localStorage.setItem(ACTIVE_TASK_KEY, String(task.id));
            localStorage.setItem(ACTIVE_TASK_DATA_KEY, JSON.stringify(task));
        } catch (err) { }
    }

    function clearPersistedTask() {
        try {
            localStorage.removeItem(ACTIVE_TASK_KEY);
            localStorage.removeItem(ACTIVE_TASK_DATA_KEY);
        } catch (err) { }
    }

    const toggleProjectCollapse = (key) =>
        setCollapsedProjects((prev) => ({ ...prev, [key]: !prev[key] }));


    const saveCaret = () => {
        const sel = window.getSelection();
        if (sel && sel.rangeCount > 0) {
            setSavedRange(sel.getRangeAt(0));
        }
    };

    // Open task with comments
    // const openTask = (task) => {
    //     setActiveTask(task);

    //     fetch(`${API_BASE_URL}/api/tasks/${task.id}/comments`, {
    //         headers: { Authorization: "Bearer " + token },
    //     })
    //         .then((res) => res.json())
    //         .then((data) => setComments(data))
    //         .catch(() => setComments([]));

    //     setEditingCommentId(null);
    //     setEditContent("");
    //     if (editRef.current) editRef.current.innerHTML = "";
    // };

    const openTask = (task) => {
        // persist before anything else
        persistActiveTask(task);

        setActiveTask(task);

        fetch(`${API_BASE_URL}/api/tasks/${task.id}/comments`, {
            headers: { Authorization: "Bearer " + token },
        })
            .then((res) => res.json())
            .then((data) => {
                const sorted = [...data].sort(
                    (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
                );
                setComments(sorted);
            })
            .catch(() => setComments([]));

        fetchWorklogs(task.id);
        fetchTaskTotalLogs(task.id);
        if (editorRef.current) editorRef.current.innerHTML = "";
        setMentions([]);
        setAttachments([]);
        setEditingCommentId(null);
        setEditContent("");
        if (editRef.current) editRef.current.innerHTML = "";
    };

    const fetchWorklogs = (taskId) => {
        fetch(`${API_BASE_URL}/api/worklogs/employee/${employeeId}/task/${taskId}`, {
            headers: { Authorization: "Bearer " + token },
        })
            .then((res) => res.json())
            .then((data) => {
                const sorted = [...data].sort(
                    (a, b) => new Date(b.date) - new Date(a.date) // DESC
                );
                setWorklogs(sorted);
            })
            .catch(() => setWorklogs([]));
    };

    const isImageFile = (fileName) => {
        const lower = fileName.toLowerCase();
        return (
            lower.endsWith(".png") ||
            lower.endsWith(".jpg") ||
            lower.endsWith(".jpeg") ||
            lower.endsWith(".gif") ||
            lower.endsWith(".bmp") ||
            lower.endsWith(".webp")
        );
    };


    {/* Helper to check if base64 has data: prefix */ }
    const getDataUrl = (file) => {
        if (!file.base64) return "";
        return file.base64.startsWith("data:")
            ? file.base64
            : `data:${getMimeType(file.name)};base64,${file.base64}`;
    };

    /* Helper to get MIME type from file name */
    const getMimeType = (filename) => {
        const ext = filename?.split(".").pop()?.toLowerCase();
        switch (ext) {
            case "jpg":
            case "jpeg":
                return "image/jpeg";
            case "png":
                return "image/png";
            case "gif":
                return "image/gif";
            case "bmp":
                return "image/bmp";
            case "webp":
                return "image/webp";
            default:
                return "application/octet-stream";
        }
    };


    const updateTaskStatus = async (taskId, newStatus) => {
        const res = await fetch(
            `${API_BASE_URL}/api/tasks/${taskId}/status?employeeId=${employeeId}&status=${newStatus}`,
            {
                method: "PUT",
                headers: { Authorization: "Bearer " + token },
            }
        );
        if (res.ok) {
            setTasks((prev) =>
                prev.map((t) =>
                    t.id === taskId ? { ...t, status: newStatus } : t
                )
            );
            if (activeTask?.id === taskId) {
                setActiveTask({ ...activeTask, status: newStatus });
            }
        }
    };

    const saveEdit = async (commentId) => {
        const plainTextEdit = editRef.current?.innerText?.trim() || "";

        // If there's no text and no attachments to keep/send, do nothing
        if (!plainTextEdit && (!editAttachments || editAttachments.length === 0)) return;

        const fileToBase64 = (file) =>
            new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result);
                reader.onerror = (e) => reject(e);
                reader.readAsDataURL(file);
            });

        // Build three things:
        // 1) keepAttachmentIds -> existing attachments the user kept (with id)
        // 2) keepAttachmentUrls -> existing attachments the user kept (with url but no id)
        // 3) newAttachments -> new files/base64 that need uploading
        const keepAttachmentIds = [];
        const keepAttachmentUrls = [];
        const newAttachments = [];
        const compatibilityAttachments = []; // old format for backwards compatibility

        // --- SYNC ATTACHMENTS AGAINST EDITOR HTML (replacement block) ---
        // read current editor html (what will be saved)
        const currentHtml = (editRef.current && editRef.current.innerHTML) || "";
        // helper: parse HTML to find image srcs and anchor hrefs and text tokens
        const temp = document.createElement("div");
        temp.innerHTML = currentHtml;

        // collect img srcs (full strings)
        const imgSrcs = Array.from(temp.querySelectorAll("img"))
            .map((img) => img.getAttribute("src"))
            .filter(Boolean);

        // collect anchor hrefs (could be file URLs)
        const anchorHrefs = Array.from(temp.querySelectorAll("a"))
            .map((a) => a.getAttribute("href"))
            .filter(Boolean);

        // collect text content tokens (useful when non-image attachments are rendered as badges with filename text)
        const textContent = temp.textContent || "";

        // helpers to check presence
        const htmlIncludes = (needle) => {
            if (!needle) return false;
            // direct equality check for src/href entries
            if (imgSrcs.includes(needle) || anchorHrefs.includes(needle)) return true;
            // fallback: substring search (useful for long data: URIs that may be slightly altered)
            return currentHtml.indexOf(needle) !== -1 || textContent.indexOf(needle) !== -1;
        };

        // reset arrays
        keepAttachmentIds.length = 0;
        keepAttachmentUrls.length = 0;
        newAttachments.length = 0;
        compatibilityAttachments.length = 0;

        for (const a of editAttachments || []) {
            if (!a) continue;

            // CASE: server-returned existing attachment with id (best-case)
            if (a.id) {
                // If the server attachment has a url, prefer to check that; else check base64
                if (a.url && htmlIncludes(a.url)) {
                    keepAttachmentIds.push(a.id);
                    compatibilityAttachments.push({ id: a.id, name: a.name, url: a.url });
                    continue;
                }
                if (a.base64 && htmlIncludes(a.base64)) {
                    keepAttachmentIds.push(a.id);
                    compatibilityAttachments.push({ id: a.id, name: a.name, base64: a.base64 });
                    continue;
                }
                // If id exists but not present in HTML, treat as removed (do not push keep)
                continue;
            }

            // CASE: attachment referenced only by url (no id)
            if (a.url) {
                if (htmlIncludes(a.url)) {
                    keepAttachmentUrls.push(a.url);
                    compatibilityAttachments.push({ url: a.url, name: a.name });
                } else {
                    // removed — skip
                }
                continue;
            }

            // CASE: base64 already present (pasted inline) -> check if it's still in HTML
            if (a.base64) {
                if (htmlIncludes(a.base64)) {
                    newAttachments.push({ name: a.name || "attachment", base64: a.base64 });
                    compatibilityAttachments.push({ name: a.name || "attachment", base64: a.base64 });
                } else {
                    // removed — skip
                }
                continue;
            }

            // CASE: File object - convert to base64 then decide if present
            if (a.file instanceof File) {
                try {
                    const base64 = await fileToBase64(a.file);
                    // If base64 is present (editor shows the pasted image) -> include as newAttachment
                    if (htmlIncludes(base64)) {
                        newAttachments.push({ name: a.name || a.file.name || "attachment", base64 });
                        compatibilityAttachments.push({ name: a.name || a.file.name || "attachment", base64 });
                    } else {
                        // Not present in HTML -> maybe user removed it -> skip
                    }
                } catch (e) {
                    console.warn("Failed to convert file to base64", a, e);
                    // fallback: if name appears in the editor text, keep a name-only compatibility entry
                    if (a.name && textContent.indexOf(a.name) !== -1) {
                        compatibilityAttachments.push({ name: a.name });
                    }
                }
                continue;
            }

            // fallback minimal: if name appears in UI text, keep it as compatibility, else skip
            if (a.name && textContent.indexOf(a.name) !== -1) {
                compatibilityAttachments.push({ name: a.name });
            }
        }



        const base = {
            text: plainTextEdit,
            html: editRef.current?.innerHTML || ""    // <-- include formatted HTML
        };

        // Build the "new" payload
        const bodyObj = {
            ...base,
            // explicit keep lists:
            ...(keepAttachmentIds.length ? { keepAttachmentIds } : {}),
            ...(keepAttachmentUrls.length ? { keepAttachmentUrls } : {}),
            ...(newAttachments.length ? { newAttachments } : {}),
            // include compatibility attachments array (so older server behavior still works)
            attachments: compatibilityAttachments,
            // optional: include mentions (if your server expects list of ids)
            ...(mentions && mentions.length ? { mentions: mentions.map(m => m.id ? m.id : (m)) } : {}),
        };

        const doFetch = async (body) =>
            fetch(`${API_BASE_URL}/api/tasks/comments/${commentId}`, {
                method: "PUT",
                headers: {
                    Authorization: "Bearer " + token,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(body),
            });

        try {
            console.log("saveEdit payload:", JSON.stringify(bodyObj, null, 2));
            let res = await doFetch(bodyObj);

            // OPTIONAL: if your server still expects attachments as a string and returns the
            // Jackson array->String error, keep your existing retry logic here.
            if (!res.ok) {
                const errText = await res.text();
                const needsStringFallback =
                    /Cannot deserialize value of type .*java\.lang\.String.*from Array value|JsonToken\.START_ARRAY/.test(errText);

                if (needsStringFallback) {
                    // For backwards compatibility, retry with attachments as JSON-string
                    const fallback = { ...base, attachments: JSON.stringify(compatibilityAttachments) };
                    console.log("Retrying saveEdit with attachments string fallback:", JSON.stringify(fallback, null, 2));
                    res = await doFetch(fallback);
                }
            }

            if (res.ok) {
                const updated = await res.json();
                setComments((prev) => prev.map((c) => (c.id === commentId ? updated : c)));

                // cleanup
                setEditingCommentId(null);
                setEditContent("");
                if (editRef.current) editRef.current.innerHTML = "";
                setEditAttachments([]);
            } else {
                const finalErr = await res.text();
                console.error("Failed to save edit after retries:", res.status, finalErr);
            }
        } catch (err) {
            console.error("Error editing comment:", err);
        }
    };

    const handleEditorInput = (e) => {
        const text = e.target.innerText;
        const lastWord = text.split(/\s/).pop();
        if (lastWord && lastWord.startsWith("@")) {
            const query = lastWord.substring(1).toLowerCase();
            const filtered = mentionableUsers.filter((u) =>
                `${u.firstName} ${u.lastName}`.toLowerCase().includes(query)
            );
            setFilteredUsers(filtered);
            setShowSuggestions(true);
        } else {
            setShowSuggestions(false);
        }
    };

    const fileToBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = (err) => reject(err);
            reader.readAsDataURL(file);
        });

    const addBase64Attachment = async (file) => {
        const base64 = await fileToBase64(file);
        setAttachments((prev) => [...prev, { name: file.name, base64 }]);

        if (file.type.startsWith("image/") && editorRef.current) {
            const img = document.createElement("img");
            img.src = base64;
            img.style.maxWidth = "200px";
            img.style.borderRadius = "6px";
            img.style.margin = "5px 0";
            editorRef.current.appendChild(img);
            moveCaretToEnd(editorRef.current);
        }
    };

    const handlePaste = (e) => {
        if (e.clipboardData && e.clipboardData.files.length > 0) {
            e.preventDefault();
            addBase64Attachment(e.clipboardData.files[0]);
        }
    };

    const handleFileUpload = (e) => {
        const files = Array.from(e.target.files);
        files.forEach(addBase64Attachment);
    };

    const addMention = (user) => {
        const fullName = `${user.firstName} ${user.lastName}`;
        const editor = editorRef.current;
        if (!editor) return;

        const sel = window.getSelection();
        sel.removeAllRanges();

        // Restore previous caret position
        if (savedRange) {
            sel.addRange(savedRange);
        }

        if (!sel.rangeCount) return;

        const range = sel.getRangeAt(0);
        const node = range.startContainer;
        let offset = range.startOffset;

        // Remove the last "@word" typed if inside a text node
        if (node.nodeType === Node.TEXT_NODE) {
            const text = node.textContent;
            const words = text.slice(0, offset).split(/\s/);
            const lastWord = words[words.length - 1] || "";

            if (lastWord.startsWith("@")) {
                const newText = words.slice(0, -1).join(" ");
                node.textContent = newText ? newText + " " : "";
                offset = node.textContent.length;
            }
        }

        // Create the mention span
        const span = document.createElement("span");
        span.className = "  me-1 text-dark";
        span.contentEditable = "false";
        span.innerText = fullName;

        // Insert the span at the caret
        range.setStart(node, offset);
        range.setEnd(node, offset);
        range.deleteContents();
        range.insertNode(span);
        range.collapse(false);

        // Add a space after the mention
        const space = document.createTextNode(" ");
        span.after(space);

        // Move caret after the mention
        sel.removeAllRanges();
        const newRange = document.createRange();
        newRange.setStartAfter(space);
        newRange.collapse(true);
        sel.addRange(newRange);

        // Update state and hide suggestions
        setMentions((prev) => [...prev, user]);
        setShowSuggestions(false);

        // Focus back to editor
        editor.focus();

        // Clear saved range
        setSavedRange(null);
    };


    const updateTaskField = async (taskId, field, value) => {
        try {
            const formData = new FormData();

            // 🟢 MANDATORY FIELDS (always required)
            formData.append("title", activeTask.title || "");
            formData.append("description", activeTask.description || "");
            formData.append(
                "dueDate",
                activeTask.dueDate
                    ? new Date(activeTask.dueDate).toISOString().split("T")[0]
                    : ""
            );
            formData.append("employeeId", activeTask.assignedTo?.id || "");
            formData.append("projectId", activeTask.project?.id || "");

            // 🟡 OPTIONAL FIELDS
            formData.append("priority", activeTask.priority || "");
            formData.append("taskType", activeTask.taskType || "");
            formData.append("teamId", activeTask.team?.id || "");
            formData.append("estimatedTime", activeTask.estimatedTime || "");
            formData.append("totalTime", activeTask.totalTime || "");
            formData.append("reporterId", activeTask.reporter?.id || "");
            formData.append("status", activeTask.status || "");

            // 🔹 OVERRIDE the single field being edited (ensure new value takes priority)
            if (value !== undefined && field) {
                formData.set(field, value);
            }

            // 🧠 Log for debugging
            console.log(
                `Updating field '${field}' with value:`,
                value,
                "→ sending full task data to backend..."
            );

            const response = await axios.put(
                `${API_BASE_URL}/api/tasks/${taskId}`,
                formData
            );

            // ✅ Update local task data
            setActiveTask(response.data);
            console.log("✅ Task updated successfully:", response.data);
        } catch (error) {
            console.error("❌ Failed to update task:", error);
        }
    };

    const deleteComment = async (commentId) => {
        try {
            const res = await fetch(
                `${API_BASE_URL}/api/tasks/comments/${commentId}`,
                {
                    method: "DELETE",
                    headers: { Authorization: "Bearer " + token },
                }
            );
            if (res.ok) {
                setComments((prev) => prev.filter((c) => c.id !== commentId));
            }
        } catch (err) {
            console.error("Error deleting comment:", err);
        }
    };

    const removeAttachment = (index) => {
        setAttachments((prev) => prev.filter((_, i) => i !== index));
    };

    const addComment = async () => {
        const plainText = editorRef.current?.innerText?.trim() || "";
        const htmlContent = editorRef.current?.innerHTML || ""; // ⬅ capture full HTML

        if (!plainText || !activeTask) return;

        const payload = {
            text: plainText,
            html: htmlContent, // ⬅ send formatted HTML
            mentions: mentions.map((m) => m.id),
            attachments,
        };

        try {
            const res = await fetch(
                `${API_BASE_URL}/api/tasks/${activeTask.id}/comments`,
                {
                    method: "POST",
                    headers: {
                        Authorization: "Bearer " + token,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                }
            );

            if (res.ok) {
                const newComment = await res.json();

                // show instantly
                setComments(prev => [newComment, ...(prev || [])]);

                // clear editor
                cancelComment();
            } else {
                console.error("Failed to save comment:", res.statusText);
            }
        } catch (err) {
            console.error("Error saving comment:", err);
        }
    };

    const cancelComment = () => {
        if (editorRef.current) editorRef.current.innerHTML = "";
        setAttachments([]);
        setMentions([]);
    };

    const submitReply = (commentId) => {
        if (!replyContent.trim()) return;

        fetch(`${API_BASE_URL}/api/tasks/comments/${commentId}/replies`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
            },
            body: JSON.stringify({
                text: replyContent,
                author: sessionStorage.getItem("username") || "Admin",
            }),
        })
            .then((res) => res.json())
            .then((newReply) => {
                setComments((prev) =>
                    prev.map((c) =>
                        c.id === commentId
                            ? { ...c, replies: [...(c.replies || []), newReply] }
                            : c
                    )
                );
                setReplyContent("");
                setReplyToCommentId(null);
            })
            .catch((err) => console.error(err));
    };

    const handleEditInput = () => {
        if (editRef.current) {
            setEditContent(editRef.current.innerText);
        }
    };

    const onDragEnd = (result) => {
        const { source, destination, draggableId } = result;
        if (!destination) return;

        // Extract only the status from droppableId (ignore projectName)
        const newStatus = destination.droppableId.split('-').slice(-1)[0];
        const taskId = parseInt(draggableId);

        // Update tasks locally
        setTasks((prev) =>
            prev.map((t) => (t.id === taskId ? { ...t, status: newStatus } : t))
        );

        // Update backend (status only)
        fetch(`/api/tasks/${taskId}/status?status=${newStatus}`, {
            method: 'PUT',
        }).catch((err) => console.error(err));
    };


    useEffect(() => {
        if (newTaskProject && projectEmployees.length > 0) {
            // if logged in employee exists inside this project employee list, auto-select it
            const exists = projectEmployees.some(emp => emp.id == loggedInEmployeeId);

            if (exists) {
                setNewTaskReporter(loggedInEmployeeId);
            }
        }
    }, [newTaskProject, projectEmployees]);


    // Function to create the task
    const createTask = async () => {
        // 🧩 Build payload safely (convert empty values to null)
        const payload = {
            title: newTaskTitle || "",
            description: newTaskDescription || "",
            dueDate: newTaskDueDate || null,
            employeeId: newTaskAssignee ? Number(newTaskAssignee) : null,
            projectId: newTaskProject ? Number(newTaskProject) : null,
            reporterId: newTaskReporter ? Number(newTaskReporter) : null,
            estimatedTime: newTaskEstimatedTime ? Number(newTaskEstimatedTime) : 0,
            totalTime: newTaskTotalTime ? Number(newTaskTotalTime) : 0,
            priority: newTaskPriority || "Medium",
            taskType: newTaskType || "Feature",
            teamId: newTaskTeam ? Number(newTaskTeam) : null,
            parentId: newTaskParent ? Number(newTaskParent) : null,
        };

        try {
            // 🧾 Include JWT token for authentication
            const token = sessionStorage.getItem("token");

            const response = await fetch(`${API_BASE_URL}/api/tasks/assign`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    ...(token && { Authorization: `Bearer ${token}` }), // only if token exists
                },
                body: JSON.stringify(payload),
            });

            if (response.ok) {
                toast.success("✅ Task created successfully!", {
                    position: "bottom-right",
                });
                setShowCreateTask(false);
                setTimeout(() => {
                    window.location.reload();
                }, 500);
            } else {
                const errorText = await response.text();
                console.error("❌ Failed to create task:", errorText);
                alert(`Failed to create task: ${errorText}`);
            }
        } catch (error) {
            console.error("⚠️ Error creating task:", error);
        }
    };

    // const uniqueEmployees = Array.from(
    //     new Set(
    //         tasks
    //             .filter((t) => t.assignedTo)
    //             .map((t) => `${t.assignedTo.firstName} ${t.assignedTo.lastName}`)
    //     )
    // );

    // ✅ Filter logic
    const applyFilters = (task) => {
        // ✅ Project filter: only filter when a specific project is selected
        if (
            selectedProject &&                     // not empty / null
            selectedProject !== "all" &&           // not "All Projects"
            String(task.project?.id) !== selectedProject
        ) {
            return false;
        }

        // Search filter
        if (searchQuery && !task.title.toLowerCase().includes(searchQuery.toLowerCase())) {
            return false;
        }

        // Due date filter
        const taskDate = task.dueDate ? new Date(task.dueDate) : null;
        const today = new Date();
        const todayStr = today.toISOString().split("T")[0];

        if (filterType === "overdue" && taskDate && taskDate >= today) return false;
        if (filterType === "today" && (!task.dueDate || task.dueDate !== todayStr)) return false;
        if (filterType === "upcoming" && taskDate && taskDate <= today) return false;

        // Assigned To filter
        if (
            assignedFilter !== "all" &&
            (!task.assignedTo ||
                `${task.assignedTo.firstName} ${task.assignedTo.lastName}` !== assignedFilter)
        ) {
            return false;
        }

        return true;
    };



    const statusColumns = [
        { key: "PENDING", title: "To Do" },
        { key: "IN_PROGRESS", title: "In Progress" },
        { key: "REVIEW", title: "Review" },
        { key: "READY TO TEST", title: "READY TO TEST" },
        { key: "IN TESTING", title: "IN TESTING" },
        { key: "COMPLETED", title: "Done" },
        { key: "CANCELLED", title: "Cancelled" },
    ];

    if (loading) return <div className="text-center mt-5">Loading...</div>;

    const renderTaskCard = (t, index) => {
        const isOverdue =
            t.dueDate && new Date() > new Date(t.dueDate) && t.status !== "COMPLETED";

        return (
            <Draggable draggableId={t.id.toString()} index={index} key={t.id}>
                {(provided, snapshot) => (
                    <div
                        className={`task-card ${snapshot.isDragging ? "task-card--dragging" : ""
                            } ${t.status === "COMPLETED" ? "task-card--done" : ""} ${isOverdue ? "task-card--overdue" : ""
                            }`}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        onClick={() => openTask(t)}
                        style={provided.draggableProps.style}
                    >
                        <div className="task-card__header">
                            <span className="task-card__assignee-name" title={t.taskCode}>
                                {t.taskCode}
                            </span>
                        </div>
                        <div className="task-card__header">
                            <span className="task-card__title" title={t.title}>
                                {t.title}
                            </span>
                        </div>

                        <div className="task-card__meta">
                            <div className="task-card__assignee-wrapper">

                                <div className="task-card__assignee">
                                    {t?.assignedTo?.photoPath ? (
                                        <img
                                            src={`/uploads/${t.assignedTo.photoPath}`}
                                            className="avatar-img"
                                            alt=""
                                        />
                                    ) : (
                                        ((t?.assignedTo?.firstName || "?")[0]).toUpperCase()
                                    )}
                                </div>


                                <span className="task-card__assignee-name">
                                    {t?.assignedTo
                                        ? `${t.assignedTo.firstName} ${t.assignedTo.lastName}`
                                        : "Unassigned"}
                                </span>


                            </div>


                            <div className="task-card__date">
                                {t.dueDate && (
                                    <>
                                        <i className="bi bi-calendar-event me-1" />
                                        {new Date(t.dueDate).toLocaleDateString("en-GB")}
                                    </>
                                )}
                            </div>
                        </div>

                        <div className="task-card__footer">
                            <span className={`status-pill status-pill--${t.status.toLowerCase().replace(/\s/g, "")}`}>
                                {t.status.replace(/_/g, " ")}
                            </span>
                            {t.priority && (
                                <span
                                    className={`priority-pill priority-pill--${t.priority
                                        .toLowerCase()
                                        .replace(/\s/g, "")}`}
                                >
                                    {t.priority}
                                </span>
                            )}
                        </div>
                    </div>
                )}
            </Draggable>
        );
    };



    return (
        <>
            <div className="fixed-top">
                <ManagerNavbar />
            </div>

            <div className="viewtasks-roots">

                {/* ---------- Projects sidebar (fixed) ---------- */}
                <div className="projects-sidebars" aria-label="projects sidebars">
                    <div className="projects-sidebars__inner p-2">
                        <div className="d-flex align-items-center justify-content-between mb-2">
                            <strong>Overview</strong>
                            {/* <button
                                className="btn btn-sm btn-light"
                                onClick={() => { setSelectedProject("all"); }}
                                title="Show all projects"
                            >
                                All
                            </button> */}
                        </div>

                        <div className="list-group mb-2">
                            <button
                                className={`list-group-item list-group-item-action ${selectedProject === "all" ? "active" : ""}`}
                                onClick={() => setSelectedProject("all")}
                            >
                                📚 All Projects
                            </button>

                            {projects.map((p) => (
                                <button
                                    key={p.id}
                                    className={`list-group-item list-group-item-action d-flex justify-content-between align-items-center ${String(selectedProject) === String(p.id) ? "active" : ""}`}
                                    onClick={() => setSelectedProject(String(p.id))}
                                    title={p.description || p.name}
                                >
                                    <span className="text-truncate" style={{ maxWidth: "140px" }}>📁 {p.name}</span>
                                    {/* <small className="text-muted ms-2">{tasks.filter(t => t.project?.id === p.id).length}</small> */}
                                </button>
                            ))}
                        </div>

                        <div className="d-grid gap-1">
                            <button
                                className="btn btn-sm btn-outline-primary"
                                onClick={() => navigate("/managertimesheetgrid", { state: { employeeId } })}
                            >
                                Timesheets
                            </button>
                        </div>
                    </div>
                </div>

                {/* MAIN PAGE: board + filters */}
                {!activeTask && (
                    <div className="viewtasks-main">
                        <div className="main-with-sidebars">
                            {/* Header */}
                            <div className="viewtasks-header">
                                <div>
                                    <h4 className="viewtasks-title mb-0">Tasks Management</h4>
                                    <p className="text-muted mb-0">
                                        Manage and review all tasks assigned to your team.
                                    </p>
                                </div>

                                <div className="d-flex align-items-center gap-2">
                                    {/* (Optional) Back button if you want */}
                                    {/* <button
                                        className="btn btn-outline-secondary btn-sm"
                                        onClick={() => navigate("/managerdashboard")}
                                    >
                                        <i className="bi bi-arrow-left-short me-1" />
                                        Back to Dashboard
                                    </button> */}
                                    <button
                                        className="btn btn-primary btn-sm"
                                        onClick={() => setShowCreateTask(true)}
                                    >
                                        {/* <i className="bi bi-plus-circle me-1" /> */}
                                        Create
                                    </button>
                                </div>
                            </div>

                            {/* Filters */}
                            <div className="card shadow-sm mb-3 border-0">
                                <div className="card-body py-2">
                                    <div className="row gy-2 gx-2 align-items-center">
                                        {/* Search */}
                                        <div className="col-md-3">
                                            <label className="form-label form-label-sm text-muted mb-1">
                                                Search
                                            </label>
                                            <input
                                                type="text"
                                                placeholder="Search by title..."
                                                className="form-control form-control-sm"
                                                value={searchQuery}
                                                onChange={(e) => setSearchQuery(e.target.value)}
                                            />
                                        </div>

                                        {/* Project */}
                                        {/* <div className="col-md-2">
                                        <label className="form-label form-label-sm text-muted mb-1">
                                            Project
                                        </label>
                                        <select
                                            className="form-select form-select-sm"
                                            
                                            value={selectedProject}
                                            onChange={(e) => setSelectedProject(e.target.value)}
                                        >
                                            <option value="all">All Projects</option>
                                            {projects.map((p) => (
                                                <option key={p.id} value={String(p.id)}>
                                                    {p.name}
                                                </option>
                                            ))}
                                        </select>

                                    </div> */}

                                        {/* Due filter */}
                                        <div className="col-md-2">
                                            <label className="form-label form-label-sm text-muted mb-1">
                                                Due
                                            </label>
                                            <select
                                                className="form-select form-select-sm"
                                                value={filterType}
                                                onChange={(e) => setFilterType(e.target.value)}
                                            >
                                                <option value="all">All</option>
                                                <option value="overdue">Overdue</option>
                                                <option value="today">Today</option>
                                                <option value="upcoming">Upcoming</option>
                                            </select>
                                        </div>

                                        {/* Assigned */}
                                        <div className="col-md-3">
                                            <label className="form-label form-label-sm text-muted mb-1">
                                                Team Members
                                            </label>
                                            <select
                                                className="form-select form-select-sm"
                                                value={assignedFilter}
                                                onChange={(e) => setAssignedFilter(e.target.value)}
                                            >
                                                <option value="all">All employees</option>
                                                {uniqueEmployees.map((name, idx) => (
                                                    <option key={idx} value={name}>
                                                        {name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Create Task Modal (unchanged logic, just slightly nicer styling) */}
                            {showCreateTask && (
                                <>
                                    <div
                                        className="modal-backdrop fade show"
                                        onClick={() => {
                                            resetCreateTaskForm();
                                            setShowCreateTask(false);
                                        }}
                                        style={{ cursor: "pointer" }}
                                    ></div>

                                    <div
                                        className="modal show fade d-block"
                                        tabIndex="-1"
                                        role="dialog"
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                                            <div className="modal-content">
                                                <form
                                                    onSubmit={(e) => {
                                                        e.preventDefault();
                                                        createTask();
                                                    }}
                                                >
                                                    <div className="modal-header bg-light">
                                                        <div>
                                                            <h5 className="modal-title fw-semibold mb-0">
                                                                Create new task
                                                            </h5>
                                                            <span className="text-muted small">
                                                                Define basic details and assign to a team member.
                                                            </span>
                                                        </div>
                                                        <button
                                                            type="button"
                                                            className="btn-close"
                                                            onClick={() => {
                                                                resetCreateTaskForm();
                                                                setShowCreateTask(false);
                                                            }}
                                                        ></button>

                                                    </div>

                                                    <div className="modal-body">
                                                        <div className="row g-3">
                                                            <div className="col-md-6">
                                                                <label className="form-label form-label-sm text-muted">
                                                                    Task title<span className="text-danger">*</span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={newTaskTitle}
                                                                    onChange={(e) => setNewTaskTitle(e.target.value)}
                                                                    required
                                                                />
                                                            </div>

                                                            <div className="col-md-6">
                                                                <label className="form-label form-label-sm text-muted">
                                                                    Project
                                                                </label>
                                                                <select
                                                                    className="form-select"
                                                                    value={newTaskProject}
                                                                    onChange={(e) => setNewTaskProject(e.target.value)}
                                                                >
                                                                    <option value="">Select project</option>
                                                                    {projects.map((p) => (
                                                                        <option key={p.id} value={p.id}>
                                                                            {p.name}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>

                                                            <div className="col-md-6">
                                                                <label className="form-label form-label-sm text-muted">
                                                                    Team
                                                                </label>
                                                                <select
                                                                    className="form-select"
                                                                    value={newTaskTeam}
                                                                    onChange={(e) => setNewTaskTeam(e.target.value)}
                                                                >
                                                                    <option value="">Select team</option>
                                                                    {teams.map((team) => (
                                                                        <option key={team.id} value={team.id}>
                                                                            {team.name}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>

                                                            <div className="col-md-4">
                                                                <label className="form-label form-label-sm text-muted">
                                                                    Task type
                                                                </label>
                                                                <select
                                                                    className="form-select"
                                                                    value={newTaskType}
                                                                    onChange={(e) => setNewTaskType(e.target.value)}
                                                                >
                                                                    <option value="">Select</option>
                                                                    <option value="Task">Task</option>
                                                                    <option value="Feature">Feature</option>
                                                                    <option value="Bug">Bug</option>
                                                                    <option value="Improvement">Improvement</option>
                                                                    <option value="Parent">Parent</option>
                                                                </select>
                                                            </div>

                                                            <div className="col-md-12">
                                                                <label className="form-label form-label-sm text-muted">
                                                                    Description
                                                                </label>
                                                                <textarea
                                                                    className="form-control"
                                                                    rows={3}
                                                                    value={newTaskDescription}
                                                                    onChange={(e) =>
                                                                        setNewTaskDescription(e.target.value)
                                                                    }
                                                                />
                                                            </div>

                                                            <div className="col-md-6">
                                                                <label className="form-label form-label-sm text-muted">
                                                                    Assignee
                                                                </label>
                                                                <select
                                                                    className="form-select"
                                                                    value={newTaskAssignee ?? ""}
                                                                    onChange={(e) => setNewTaskAssignee(e.target.value)}
                                                                    disabled={!newTaskProject}  // disable until project selected
                                                                >
                                                                    <option value="">
                                                                        {newTaskProject ? "Select Assignee" : "Select project first"}
                                                                    </option>

                                                                    {projectEmployees.map((emp) => (
                                                                        <option key={emp.id} value={emp.id}>
                                                                            {emp.firstName} {emp.lastName}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>

                                                            <div className="col-md-6">
                                                                <label className="form-label form-label-sm text-muted">
                                                                    Reporter
                                                                </label>
                                                                <select
                                                                    className="form-select"
                                                                    value={newTaskReporter}
                                                                    onChange={(e) => setNewTaskReporter(e.target.value)}
                                                                    style={{
                                                                        pointerEvents: "none",
                                                                        backgroundColor: "#f8f9fa",
                                                                        cursor: "not-allowed",
                                                                        appearance: "none",
                                                                        WebkitAppearance: "none",
                                                                        MozAppearance: "none",
                                                                        backgroundImage: "none"
                                                                    }}
                                                                >
                                                                    <option value="">
                                                                        {newTaskProject ? "Select Reporter" : "Select project first"}
                                                                    </option>

                                                                    {projectEmployees.map((emp) => (
                                                                        <option key={emp.id} value={emp.id}>
                                                                            {emp.firstName} {emp.lastName}
                                                                        </option>
                                                                    ))}
                                                                </select>


                                                            </div>

                                                            {/* Parent (select) */}
                                                            <div className="col-md-6">
                                                                <label className="form-label fw-semibold small text-muted">Parent</label>
                                                                <select
                                                                    className="form-select"
                                                                    value={newTaskParent}
                                                                    onChange={(e) => setNewTaskParent(e.target.value)}
                                                                    disabled={newTaskType === "Parent"}
                                                                    title={newTaskType === "Parent" ? "Parent task cannot have a parent" : "Select parent task (optional)"}
                                                                >
                                                                    <option value="">Select Parent (optional)</option>

                                                                    {parentTasks
                                                                        .filter(t =>
                                                                            t &&
                                                                            t.id &&
                                                                            t.project?.id === Number(newTaskProject) // ✅ only parent tasks of THIS project
                                                                        )
                                                                        .sort((a, b) => (a.title || "").localeCompare(b.title || ""))
                                                                        .map(t => (
                                                                            <option key={t.id} value={t.id}>
                                                                                {t.title}
                                                                            </option>
                                                                        ))
                                                                    }
                                                                </select>
                                                            </div>


                                                            <div className="col-md-4">
                                                                <label className="form-label fw-semibold small text-muted">Due Date</label>
                                                                <input
                                                                    type="date"
                                                                    className="form-control"
                                                                    value={newTaskDueDate}
                                                                    min={new Date().toISOString().split("T")[0]}   // 🚀 sets today as minimum
                                                                    onChange={(e) => setNewTaskDueDate(e.target.value)}
                                                                />
                                                            </div>


                                                            <div className="col-md-4">
                                                                <label className="form-label form-label-sm text-muted">
                                                                    Priority
                                                                </label>
                                                                <select
                                                                    className="form-select"
                                                                    value={newTaskPriority}
                                                                    onChange={(e) => setNewTaskPriority(e.target.value)}
                                                                >
                                                                    <option value="Medium">Medium</option>
                                                                    <option value="High">High</option>
                                                                    <option value="Low">Low</option>
                                                                </select>
                                                            </div>



                                                            <div className="col-md-2">
                                                                <label className="form-label form-label-sm text-muted">
                                                                    Est. time (hrs)
                                                                </label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    value={newTaskEstimatedTime}
                                                                    onChange={(e) =>
                                                                        setNewTaskEstimatedTime(e.target.value)
                                                                    }
                                                                />
                                                            </div>

                                                            {/* <div className="col-md-2">
                                                                <label className="form-label form-label-sm text-muted">
                                                                    Total time (hrs)
                                                                </label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    value={newTaskTotalTime}
                                                                    onChange={(e) =>
                                                                        setNewTaskTotalTime(e.target.value)
                                                                    }
                                                                />
                                                            </div> */}
                                                        </div>
                                                    </div>

                                                    <div className="modal-footer">
                                                        <button type="submit" className="btn btn-primary btn-sm">
                                                            Create
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="btn btn-light btn-sm"
                                                            onClick={() => {
                                                                resetCreateTaskForm();
                                                                setShowCreateTask(false);
                                                            }}
                                                        >
                                                            Cancel
                                                        </button>

                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}

                            {/* Kanban board */}
                            <div
                                className="kanban-wrapper"
                                style={{ flex: 1, minHeight: 0, overflowX: "auto", overflowY: "auto", marginTop: 4 }}
                            >
                                <DragDropContext onDragEnd={onDragEnd}>
                                    {selectedProject && selectedProject !== "all" ? (
                                        // SINGLE PROJECT VIEW wrapped in project card + collapsible body
                                        (() => {
                                            const proj = projects.find((p) => p.id.toString() === selectedProject);
                                            const projectKey = proj ? `p_${proj.id}` : "single";
                                            const isCollapsed = !!collapsedProjects[projectKey];

                                            return (
                                                <div
                                                    className="project-kanban mb-4"
                                                    style={{
                                                        padding: 12,
                                                        borderRadius: 10,
                                                        background: "#ffffff",
                                                        boxShadow: "0 1px 6px rgba(15,23,42,0.06)",
                                                        border: "1px solid #eef2ff",
                                                    }}
                                                >
                                                    {/* Header with collapse toggle (inside container) */}
                                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 }}>
                                                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                            <button
                                                                onClick={() => toggleProjectCollapse(projectKey)}
                                                                aria-expanded={!isCollapsed}
                                                                style={{ border: "none", background: "transparent", cursor: "pointer", fontSize: 18, lineHeight: 1 }}
                                                                title={isCollapsed ? "Expand" : "Collapse"}
                                                            >
                                                                {isCollapsed ? "▸" : "▾"}
                                                            </button>

                                                            <div style={{ fontSize: "1rem", fontWeight: 600 }}>
                                                                📁 {proj ? proj.name : "Selected project"}
                                                            </div>
                                                        </div>

                                                        <div style={{ fontSize: "0.8rem", color: "#6b7280" }}>
                                                            {tasks.filter((t) => t.project?.id.toString() === selectedProject).length} tasks
                                                        </div>
                                                    </div>

                                                    {/* Collapsible body */}
                                                    {!isCollapsed && (
                                                        <div className="kanban-board" style={{ display: "flex", gap: "1rem", paddingBottom: "1rem", overflowX: "auto" }}>
                                                            {statusColumns.map((col) => {
                                                                const filteredTasks = tasks
                                                                    .filter((t) => t.status === col.key)
                                                                    .filter(applyFilters);

                                                                return (
                                                                    <Droppable droppableId={col.key} key={col.key}>
                                                                        {(provided) => (
                                                                            <div className="kanban-column" ref={provided.innerRef} {...provided.droppableProps}>
                                                                                <div className="kanban-column__header">
                                                                                    <span className="kanban-column__title">{col.title}</span>
                                                                                    <span className="kanban-column__count">{filteredTasks.length}</span>
                                                                                </div>
                                                                                <div className="kanban-column__body">
                                                                                    {filteredTasks.length === 0 && <div className="kanban-column__empty">No tasks</div>}
                                                                                    {filteredTasks.map((t, index) => renderTaskCard(t, index))}
                                                                                    {provided.placeholder}
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </Droppable>
                                                                );
                                                            })}
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })()
                                    ) : (
                                        // GROUPED BY PROJECT (all projects) — stacked, each collapsible
                                        Object.entries(
                                            tasks.reduce((acc, t) => {
                                                const projectName = t.project ? t.project.name : "No Project";
                                                if (!acc[projectName]) acc[projectName] = [];
                                                acc[projectName].push(t);
                                                return acc;
                                            }, {})
                                        ).map(([projectName, projectTasks]) => {
                                            const projectKey = `g_${projectName.replace(/\s+/g, "_")}`;
                                            const isCollapsed = !!collapsedProjects[projectKey];

                                            return (
                                                <div key={projectName} className="mb-4">
                                                    <div
                                                        className="kanban-header"
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "space-between",
                                                            padding: "8px 0",
                                                        }}
                                                    >
                                                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                            <button
                                                                onClick={() => toggleProjectCollapse(projectKey)}
                                                                aria-expanded={!isCollapsed}
                                                                style={{ border: "none", background: "transparent", cursor: "pointer", fontSize: 18, lineHeight: 1 }}
                                                                title={isCollapsed ? "Expand" : "Collapse"}
                                                            >
                                                                {isCollapsed ? "▸" : "▾"}
                                                            </button>

                                                            <h6 className="mb-0" style={{ fontWeight: 600 }}>
                                                                📁 {projectName}
                                                            </h6>
                                                        </div>

                                                        <div style={{ fontSize: "0.85rem", color: "#6b7280" }}>{projectTasks.length} tasks</div>
                                                    </div>

                                                    {/* Collapsible body for this project */}
                                                    {!isCollapsed && (
                                                        <div className="kanban-board" style={{ display: "flex", gap: "1rem", paddingBottom: "1rem", overflowX: "auto" }}>
                                                            {statusColumns.map((col) => {
                                                                const filteredTasks = projectTasks.filter((t) => t.status === col.key).filter(applyFilters);
                                                                const droppableId = `${projectName}-${col.key}`;

                                                                return (
                                                                    <Droppable droppableId={droppableId} key={droppableId}>
                                                                        {(provided) => (
                                                                            <div className="kanban-column" ref={provided.innerRef} {...provided.droppableProps}>
                                                                                <div className="kanban-column__header">
                                                                                    <span className="kanban-column__title">{col.title}</span>
                                                                                    <span className="kanban-column__count">{filteredTasks.length}</span>
                                                                                </div>
                                                                                <div className="kanban-column__body">
                                                                                    {filteredTasks.length === 0 && <div className="kanban-column__empty">No tasks</div>}
                                                                                    {filteredTasks.map((t, index) => renderTaskCard(t, index))}
                                                                                    {provided.placeholder}
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </Droppable>
                                                                );
                                                            })}
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })
                                    )}
                                </DragDropContext>
                            </div>

                        </div>
                    </div>
                )}

                {/* Drawer: show only when a task is active */}
                {/* ✅ Task Details Popup Modal */}
                {activeTask && (
                    <>
                        {/* Dimmed overlay */}
                        <div
                            className="modal-backdrop fade show"
                            onClick={() => setActiveTask(null)}
                            style={{ cursor: "pointer" }}
                        ></div>

                        {/* Bootstrap modal */}
                        <div
                            className="modal show fade d-block"
                            tabIndex="-1"
                            role="dialog"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div
                                className={`modal-dialog modal-dialog-centered ${isFullscreen ? "modal-fullscreen" : "modal-xl"
                                    }`}
                                role="document"
                            >
                                <div className="modal-content task-modal-emp" style={{
                                    maxHeight: isFullscreen ? "100vh" : "90vh",
                                    overflowY: "auto",
                                }}>

                                    <div
                                        className="modal-header bg-light d-flex justify-content-between align-items-center"
                                        style={{
                                            position: "sticky",
                                            top: 0,
                                            zIndex: 1050,
                                            background: "#f8f9fa",
                                            boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                                            paddingTop: "12px",
                                            paddingBottom: "12px",
                                        }}
                                    >
                                        <div style={{ paddingRight: "10px" }}>
                                            {/* ✅ Task Code (open new tab + copy URL) */}
                                            <div className="mb-1 d-flex align-items-center" style={{ gap: "8px" }}>
                                                <small
                                                    className="text-uppercase text-muted fw-semibold"
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => {
                                                        if (activeTask?.id) {
                                                            // window.open(`/empprojtask/${activeTask.id}`, "_blank");
                                                        }
                                                    }}
                                                    title="Open task in new window"
                                                >
                                                    {activeTask?.taskCode || "TASK-CODE"}
                                                </small>

                                                {/* 📋 Copy Button */}
                                                {/* <span
                          style={{
                            cursor: "pointer",
                            fontSize: "0.85rem",
                            color: "#6c757d",
                            userSelect: "none",
                          }}
                          title="Copy link"
                          onClick={() => {
                            if (activeTask?.id) {
                              const url = `${window.location.origin}/tasks/${activeTask.id}`;
                              navigator.clipboard.writeText(url);
                              if (window?.toast) toast.success("Link copied!");
                            }
                          }}
                        >
                          📋
                        </span> */}
                                            </div>

                                            {/* ✅ Title Section */}
                                            <div className="task-section mb-0">
                                                {editField === "title" ? (
                                                    <div>
                                                        <input
                                                            type="text"
                                                            className="form-control mb-2"
                                                            value={editedTask.title || ""}
                                                            onChange={(e) =>
                                                                setEditedTask({ ...editedTask, title: e.target.value })
                                                            }
                                                            autoFocus
                                                            style={{ fontSize: "1.1rem", fontWeight: "600" }}
                                                        />

                                                        {/* Action buttons */}
                                                        <div className="d-flex gap-2">
                                                            <button
                                                                className="btn btn-sm btn-primary"
                                                                onClick={() => {
                                                                    if (activeTask && editedTask.title?.trim()) {
                                                                        updateTaskField(activeTask.id, "title", editedTask.title);
                                                                    }
                                                                    setEditField(null);
                                                                }}
                                                            >
                                                                Save
                                                            </button>

                                                            <button
                                                                className="btn btn-sm btn-outline-secondary"
                                                                onClick={() => {
                                                                    setEditedTask(activeTask); // revert changes
                                                                    setEditField(null);
                                                                }}
                                                            >
                                                                Cancel
                                                            </button>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <h5
                                                        className="modal-title fw-semibold mb-0"
                                                        onClick={() => {
                                                            if (activeTask) {
                                                                setEditedTask({ ...activeTask });
                                                                setEditField("title");
                                                            }
                                                        }}
                                                        style={{ cursor: "pointer" }}
                                                        title="Click to edit title"
                                                    >
                                                        {activeTask?.title ? (
                                                            activeTask.title
                                                        ) : (
                                                            <span className="text-muted fst-italic">
                                                                Click to add title...
                                                            </span>
                                                        )}
                                                    </h5>
                                                )}
                                            </div>
                                        </div>

                                        <div className="d-flex align-items-center gap-2">
                                            {/* Fullscreen toggle */}
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-outline-secondary d-flex align-items-center justify-content-center"
                                                onClick={() => setIsFullscreen(!isFullscreen)}
                                                title={isFullscreen ? "Exit fullscreen" : "Enter fullscreen"}
                                                style={{ width: 36, height: 36 }}
                                            >
                                                <i className={isFullscreen ? "bi bi-fullscreen-exit" : "bi bi-fullscreen"}></i>
                                            </button>



                                            {/* Close button */}
                                            <button type="button" className="btn-close" onClick={() => {
                                                clearPersistedTask();
                                                closeModal();
                                            }}></button>

                                        </div>
                                    </div>


                                    <div className="modal-body task-modal-emp__body">
                                        <div className="row g-3">
                                            {/* LEFT: Main Task Content */}
                                            <div className="col-md-8 task-modal-emp__main">
                                                <div className="task-section mb-3">
                                                    <div className="task-section__header">
                                                        <h6 className="task-section__title mb-0">Description</h6>
                                                    </div>

                                                    {editField === "description" ? (
                                                        <div className="mt-2">
                                                            <textarea
                                                                className="form-control"
                                                                rows={4}
                                                                value={editedTask?.description || ""}
                                                                onChange={(e) =>
                                                                    setEditedTask({ ...editedTask, description: e.target.value })
                                                                }
                                                                onBlur={() => {
                                                                    // keep edit mode open on blur if user clicked Save/Cancel quickly:
                                                                    // don't auto-save on blur to avoid accidental saves — we save with explicit buttons
                                                                }}
                                                                onKeyDown={(e) => {
                                                                    // Ctrl+Enter to save, Esc to cancel
                                                                    if ((e.ctrlKey || e.metaKey) && e.key === "Enter") {
                                                                        e.preventDefault();
                                                                        (async () => {
                                                                            try {
                                                                                await updateTaskField(activeTask.id, "description", editedTask.description);
                                                                            } catch (err) {
                                                                                console.error("Save failed", err);
                                                                            } finally {
                                                                                setEditField(null);
                                                                            }
                                                                        })();
                                                                    } else if (e.key === "Escape") {
                                                                        e.preventDefault();
                                                                        // revert edits
                                                                        setEditedTask({ ...activeTask });
                                                                        setEditField(null);
                                                                    }
                                                                }}
                                                                autoFocus
                                                            />
                                                            <div className="mt-2 d-flex gap-2">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-primary"
                                                                    onClick={async () => {
                                                                        try {
                                                                            await updateTaskField(activeTask.id, "description", editedTask.description);
                                                                        } catch (err) {
                                                                            console.error("Save failed", err);
                                                                            // optionally show toast here
                                                                        } finally {
                                                                            setEditField(null);
                                                                        }
                                                                    }}
                                                                >
                                                                    Save
                                                                </button>

                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-outline-secondary"
                                                                    onClick={() => {
                                                                        // revert changes & exit edit mode
                                                                        setEditedTask({ ...activeTask });
                                                                        setEditField(null);
                                                                    }}
                                                                >
                                                                    Cancel
                                                                </button>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div
                                                            className="task-section__body description-text"
                                                            onClick={() => {
                                                                setEditedTask({ ...activeTask });
                                                                setEditField("description");
                                                                // optional: scroll into view or focus handling can be added here
                                                            }}
                                                        >
                                                            {activeTask?.description ? (
                                                                <div dangerouslySetInnerHTML={{ __html: activeTask.description }} />
                                                            ) : (
                                                                <span className="text-muted fst-italic">
                                                                    Click to add description...
                                                                </span>
                                                            )}
                                                        </div>
                                                    )}

                                                </div>


                                                {/* Worklogs Section */}
                                                <div className="card shadow-none border-0 task-section task-section--worklogs">
                                                    <div className="card-body">

                                                        <div className="d-flex align-items-center mb-3" style={{ gap: "10px" }}>
                                                            <h5 className="fw-bold mb-0"> Worklogs</h5>
                                                            <button
                                                                className="btn btn-sm btn-primary mb-0"
                                                                onClick={() => setShowLogForm(!showLogForm)}
                                                            >
                                                                Log Time
                                                            </button>
                                                        </div>


                                                        <div className="row">
                                                            {/* LEFT: Log Form + Worklogs */}
                                                            <div className="col-md-12">
                                                                {showLogForm && (
                                                                    <>
                                                                        {/* Dimmed overlay that closes modal on click */}
                                                                        <div
                                                                            className="modal-backdrop fade show"
                                                                            onClick={() => setShowLogForm(false)}
                                                                            style={{ cursor: "pointer" }}
                                                                        ></div>

                                                                        {/* Modal */}
                                                                        <div
                                                                            className="modal show fade d-block"
                                                                            tabIndex="-1"
                                                                            role="dialog"
                                                                            onClick={(e) => e.stopPropagation()} // prevent clicks inside modal from closing it
                                                                        >
                                                                            <div className="modal-dialog modal-md modal-dialog-centered" role="document">
                                                                                <div className="modal-content">
                                                                                    <form
                                                                                        onSubmit={(e) => {
                                                                                            e.preventDefault();
                                                                                            saveWorklog();
                                                                                        }}
                                                                                    >
                                                                                        {/* Header */}
                                                                                        <div className="modal-header border-bottom bg-light">
                                                                                            <h5 className="modal-title fw-semibold">
                                                                                                <i className="bi bi-clock me-2 text-primary"></i> Log Time
                                                                                            </h5>
                                                                                            <button
                                                                                                type="button"
                                                                                                className="btn-close"
                                                                                                onClick={() => setShowLogForm(false)}
                                                                                            ></button>
                                                                                        </div>

                                                                                        {/* Body */}
                                                                                        <div className="modal-body">

                                                                                            {/* ✅ Task at top */}
                                                                                            <div className="mb-3 ">
                                                                                                <label className="form-label fw-semibold small text-muted " style={{ width: "450px", textAlign: "left" }}>Task</label>
                                                                                                <div className="input-group">
                                                                                                    <span className="input-group-text bg-white">
                                                                                                        <i className="bi bi-clipboard"></i>
                                                                                                    </span>
                                                                                                    <input
                                                                                                        type="text"
                                                                                                        className="form-control"
                                                                                                        value={activeTask?.title || ""}
                                                                                                        readOnly
                                                                                                    />
                                                                                                </div>
                                                                                            </div>

                                                                                            {/* Date + Duration */}
                                                                                            <div className="row g-3 mb-3">
                                                                                                <div className="col-6">
                                                                                                    <label className="form-label fw-semibold small text-muted">Date</label>
                                                                                                    <input
                                                                                                        type="date"
                                                                                                        className="form-control"
                                                                                                        value={logDate}
                                                                                                        onChange={(e) => {
                                                                                                            setLogDate(e.target.value);
                                                                                                            setSelectedDate(new Date(e.target.value));
                                                                                                        }}
                                                                                                        required
                                                                                                    />
                                                                                                </div>
                                                                                                <div className="col-6">
                                                                                                    <label className="form-label fw-semibold small text-muted">Duration</label>

                                                                                                    <div className="input-group">
                                                                                                        <input
                                                                                                            type="text"
                                                                                                            className="form-control"
                                                                                                            placeholder=""
                                                                                                            value={logHoursRaw}
                                                                                                            onChange={(e) => handleDurationChange(e.target.value)}
                                                                                                            onBlur={handleDurationBlur}
                                                                                                            onFocus={handleDurationFocus}
                                                                                                            required
                                                                                                        />
                                                                                                        {/* <span className="input-group-text">h</span> */}
                                                                                                    </div>

                                                                                                    {/* <small className="text-muted d-block">
                                                    Enter decimal or human time. Will display as readable after you leave the field.
                                                  </small> */}

                                                                                                    {/* Optional live parsed hint — remove if you don't want it */}
                                                                                                    {/* {logHoursDecimal > 0 && (
                                                    <div className="mt-1">
                                                      <small className="text-success">
                                                        Parsed: {formatDecimalToReadable(logHoursDecimal)} ({logHoursDecimal} h)
                                                      </small>
                                                    </div>
                                                  )} */}
                                                                                                </div>


                                                                                            </div>

                                                                                            {/* Billing Type */}
                                                                                            <div className="mb-3">
                                                                                                {/* <label className="form-label fw-semibold small text-muted" style={{ width: "450px", textAlign: "left" }}>Billing Type</label> */}
                                                                                                <div className="d-flex gap-4 mt-1">
                                                                                                    <div className="form-check">
                                                                                                        <input
                                                                                                            className="form-check-input"
                                                                                                            type="radio"
                                                                                                            name="billingType"
                                                                                                            id="billable"
                                                                                                            value="billable"
                                                                                                            checked={billingType === "billable"}
                                                                                                            onChange={(e) => setBillingType(e.target.value)}
                                                                                                        />
                                                                                                        <label className="form-check-label" htmlFor="billable">
                                                                                                            Billable
                                                                                                        </label>
                                                                                                    </div>
                                                                                                    <div className="form-check">
                                                                                                        <input
                                                                                                            className="form-check-input"
                                                                                                            type="radio"
                                                                                                            name="billingType"
                                                                                                            id="nonBillable"
                                                                                                            value="non-billable"
                                                                                                            checked={billingType === "non-billable"}
                                                                                                            onChange={(e) => setBillingType(e.target.value)}
                                                                                                        />
                                                                                                        <label className="form-check-label" htmlFor="nonBillable">
                                                                                                            Non-Billable
                                                                                                        </label>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>

                                                                                            {/* Description */}
                                                                                            <div className="mb-3">
                                                                                                <label className="form-label fw-semibold small text-muted" style={{ width: "450px", textAlign: "left" }}>Description</label>
                                                                                                <textarea
                                                                                                    className="form-control"
                                                                                                    rows="3"
                                                                                                    placeholder="What did you work on?"
                                                                                                    value={logDescription}
                                                                                                    onChange={(e) => setLogDescription(e.target.value)}
                                                                                                    required
                                                                                                ></textarea>
                                                                                            </div>
                                                                                        </div>

                                                                                        {/* Footer */}
                                                                                        <div className="modal-footer border-top">
                                                                                            {/* <div className="form-check me-auto">
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  id="logAnother"
                                                  checked={logAnother}
                                                  onChange={(e) => setLogAnother(e.target.checked)}
                                                />
                                                <label className="form-check-label small" htmlFor="logAnother">
                                                  Log another
                                                </label>
                                              </div> */}
                                                                                            <button type="submit" className="btn btn-primary">
                                                                                                Log time
                                                                                            </button>
                                                                                            <button
                                                                                                type="button"
                                                                                                className="btn btn-light "
                                                                                                onClick={() => setShowLogForm(false)}
                                                                                            >
                                                                                                Cancel
                                                                                            </button>
                                                                                        </div>
                                                                                    </form>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                )}


                                                                {/* Attachment Gallery – show ONLY if attachments exist */}
                                                                {taskAttachments.length > 0 && (
                                                                    <div className="card shadow-none border-0 mt-3">
                                                                        <div className="card-body">
                                                                            <h6 className="fw-semibold mb-3 text-start">
                                                                                Attachments ({taskAttachments.length})
                                                                            </h6>

                                                                            <div className="d-flex flex-wrap gap-3">
                                                                                {taskAttachments.map((file, index) => {
                                                                                    const isImage = file.name?.match(/\.(jpeg|jpg|png|gif|bmp|webp)$/i);
                                                                                    const fileUrl = getDataUrl(file);

                                                                                    return (
                                                                                        <div
                                                                                            key={index}
                                                                                            className="position-relative border rounded shadow-sm bg-white"
                                                                                            style={{
                                                                                                width: "130px",
                                                                                                height: "130px",
                                                                                                overflow: "hidden",
                                                                                                cursor: "pointer",
                                                                                                transition: "transform 0.2s ease",
                                                                                            }}
                                                                                            onClick={() => {
                                                                                                if (isImage) {
                                                                                                    const images = taskAttachments
                                                                                                        .filter(f => f.name?.match(/\.(jpeg|jpg|png|gif|bmp|webp)$/i))
                                                                                                        .map(f => getDataUrl(f));
                                                                                                    setPreviewImages(images);
                                                                                                    setCurrentImageIndex(images.indexOf(fileUrl));
                                                                                                } else {
                                                                                                    window.open(fileUrl, "_blank");
                                                                                                }
                                                                                            }}
                                                                                        >
                                                                                            {isImage ? (
                                                                                                <img
                                                                                                    src={fileUrl}
                                                                                                    alt={file.name}
                                                                                                    className="w-100 h-100"
                                                                                                    style={{ objectFit: "cover" }}
                                                                                                />
                                                                                            ) : (
                                                                                                <div className="d-flex align-items-center justify-content-center h-100 text-secondary bg-light">
                                                                                                    <i className="bi bi-file-earmark-text fs-1"></i>
                                                                                                </div>
                                                                                            )}

                                                                                            <div
                                                                                                className="position-absolute bottom-0 w-100 bg-dark bg-opacity-50 text-white text-truncate small px-1 py-1"
                                                                                                title={file.name}
                                                                                            >
                                                                                                {file.name}
                                                                                            </div>
                                                                                        </div>
                                                                                    );
                                                                                })}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}


                                                                {/* 🔍 Image Preview Modal */}
                                                                {previewImages.length > 0 && (
                                                                    <div
                                                                        className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                                                                        style={{ background: "rgba(0,0,0,0.8)", zIndex: 1050 }}
                                                                        onClick={() => setPreviewImages([])}
                                                                    >
                                                                        <div className="position-relative" onClick={(e) => e.stopPropagation()}>
                                                                            <img
                                                                                src={previewImages[currentImageIndex]}
                                                                                alt="Preview"
                                                                                style={{ maxHeight: "80vh", maxWidth: "80vw", borderRadius: "8px" }}
                                                                            />

                                                                            {/* Previous */}
                                                                            {currentImageIndex > 0 && (
                                                                                <button
                                                                                    className="btn btn-dark position-absolute top-50 start-0 translate-middle-y"
                                                                                    style={{ opacity: 0.7 }}
                                                                                    onClick={() => setCurrentImageIndex(currentImageIndex - 1)}
                                                                                >
                                                                                    ‹
                                                                                </button>
                                                                            )}

                                                                            {/* Next */}
                                                                            {currentImageIndex < previewImages.length - 1 && (
                                                                                <button
                                                                                    className="btn btn-dark position-absolute top-50 end-0 translate-middle-y"
                                                                                    style={{ opacity: 0.7 }}
                                                                                    onClick={() => setCurrentImageIndex(currentImageIndex + 1)}
                                                                                >
                                                                                    ›
                                                                                </button>
                                                                            )}

                                                                            {/* Close */}
                                                                            <button
                                                                                className="btn btn-danger position-absolute top-0 end-0 m-3"
                                                                                onClick={() => setPreviewImages([])}
                                                                            >
                                                                                ✕
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                )}



                                                                {/* Worklog list (no filters, no pagination) */}
                                                                {filteredLogs.length > 0 ? (
                                                                    <div
                                                                        className="worklog-list-scroll"
                                                                        style={{
                                                                            maxHeight: "300px",   // 👈 adjust height as needed (e.g., 250px–400px)
                                                                            overflowY: "auto",
                                                                            border: "1px solid #eee",
                                                                            borderRadius: "6px",
                                                                        }}
                                                                    >
                                                                        <ul className="list-group mt-3 mb-0">
                                                                            {filteredLogs.map((log) => (
                                                                                <li
                                                                                    key={log.id}
                                                                                    className="list-group-item d-flex justify-content-between align-items-center"
                                                                                >
                                                                                    <div>
                                                                                        <div className="fw-normal text-start">
                                                                                            {log.description || "No description"}
                                                                                        </div>
                                                                                        <small className="text-start w-100 d-block">
                                                                                            {new Date(log.date).toLocaleDateString("en-GB")} ·{" "}
                                                                                            {log.billingType === "billable"
                                                                                                ? " Billable"
                                                                                                : " Non-billable"}
                                                                                        </small>
                                                                                    </div>

                                                                                    <div className="d-flex align-items-center gap-2">
                                                                                        <span>{formatH(log.hours)}</span>


                                                                                        {/* ✏️ Edit button */}
                                                                                        <span
                                                                                            style={{ cursor: "pointer", fontSize: "18px" }}
                                                                                            title="Edit Worklog"
                                                                                            onClick={() => editWorklog(log)}
                                                                                        >
                                                                                            <svg
                                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                                width="16"
                                                                                                height="16"
                                                                                                fill="black"
                                                                                                className="bi bi-pencil"
                                                                                                viewBox="0 0 16 16"
                                                                                            >
                                                                                                <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 
                                                        10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 
                                                        0 1-.65-.65l2-5a.5.5 0 0 1 
                                                        .11-.168zM11.207 2.5 13.5 4.793 
                                                        14.793 3.5 12.5 1.207zm1.586 3L10.5 
                                                        3.207 4 9.707V10h.5a.5.5 0 0 1 
                                                        .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293z" />
                                                                                            </svg>
                                                                                        </span>

                                                                                        {/* 🗑 Delete button */}
                                                                                        <span
                                                                                            style={{ cursor: "pointer", color: "red", fontSize: "18px" }}
                                                                                            title="Delete Worklog"
                                                                                            onClick={() => deleteWorklog(log.id)}
                                                                                        >
                                                                                            <svg
                                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                                width="16"
                                                                                                height="16"
                                                                                                fill="red"
                                                                                                className="bi bi-trash"
                                                                                                viewBox="0 0 16 16"
                                                                                            >
                                                                                                <path
                                                                                                    d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 
                                                      0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 
                                                      .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 
                                                      .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 
                                                      0 0 0 1 0z"
                                                                                                />
                                                                                                <path
                                                                                                    d="M14.5 3a1 1 0 0 1-1 
                                                    1H13v9a2 2 0 0 1-2 
                                                    2H5a2 2 0 0 1-2-2V4h-.5a1 
                                                    1 0 0 1-1-1V2a1 1 0 0 
                                                    1 1-1H6a1 1 0 0 1 1-1h2a1 
                                                    1 0 0 1 1 1h3.5a1 1 0 0 1 
                                                    1 1zM4.118 4 4 4.059V13a1 
                                                    1 0 0 0 1 1h6a1 1 0 0 0 
                                                    1-1V4.059L11.882 4zM2.5 
                                                    3h11V2h-11z"
                                                                                                />
                                                                                            </svg>
                                                                                        </span>
                                                                                    </div>
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    </div>
                                                                ) : (
                                                                    <p className="text-muted mt-3">No worklogs available.</p>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>



                                                {/* New Comment — improved UI */}
                                                <div className="card shadow-sm border-0 task-section task-section--comments">
                                                    <div className="card-body col-md-12 p-3">

                                                        {/* Toolbar (floating & nicer) */}
                                                        <div
                                                            className="d-flex gap-2 flex-wrap align-items-center mb-2"
                                                            style={{
                                                                borderBottom: "1px solid #eee",
                                                                paddingBottom: "8px",
                                                            }}
                                                        >
                                                            <div className="d-flex gap-1" style={{ alignItems: "center" }}>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-outline-secondary"
                                                                    title="Bold (Ctrl+B)"
                                                                    onClick={() => document.execCommand("bold")}
                                                                >
                                                                    <b>B</b>
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-outline-secondary"
                                                                    title="Italic (Ctrl+I)"
                                                                    onClick={() => document.execCommand("italic")}
                                                                >
                                                                    <i>I</i>
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-outline-secondary"
                                                                    title="Underline (Ctrl+U)"
                                                                    onClick={() => document.execCommand("underline")}
                                                                >
                                                                    <u>U</u>
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-outline-secondary"
                                                                    title="Bulleted List"
                                                                    onClick={() => document.execCommand("insertUnorderedList")}
                                                                >
                                                                    <i className="bi bi-list-ul"></i>
                                                                </button>

                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-outline-secondary"
                                                                    title="Numbered List"
                                                                    onClick={() => document.execCommand("insertOrderedList")}
                                                                >
                                                                    <i className="bi bi-list-ol"></i>
                                                                </button>

                                                                <div style={{ position: "relative" }}>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-sm btn-outline-secondary"
                                                                        title="Text Color"
                                                                        onClick={() => document.getElementById("colorPickerInput").click()}
                                                                    >
                                                                        <i className="bi bi-palette"></i>
                                                                    </button>

                                                                    <input
                                                                        type="color"
                                                                        id="colorPickerInput"
                                                                        style={{ visibility: "hidden", position: "absolute" }}
                                                                        onChange={(e) => document.execCommand("foreColor", false, e.target.value)}
                                                                    />
                                                                </div>


                                                                <div style={{ position: "relative" }}>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-sm btn-outline-secondary"
                                                                        title="Highlight Color"
                                                                        onClick={() => document.getElementById("highlightPickerInput").click()}
                                                                    >
                                                                        <i className="bi bi-highlighter"></i>
                                                                    </button>

                                                                    <input
                                                                        type="color"
                                                                        id="highlightPickerInput"
                                                                        style={{ visibility: "hidden", position: "absolute" }}
                                                                        onChange={(e) =>
                                                                            document.execCommand("hiliteColor", false, e.target.value)
                                                                        }
                                                                    />
                                                                </div>



                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-outline-secondary"
                                                                    title="Insert link"
                                                                    onClick={() => {
                                                                        const url = prompt("Enter link URL:");
                                                                        if (url) document.execCommand("createLink", false, url);
                                                                    }}
                                                                >
                                                                    🔗
                                                                </button>


                                                                {/* Attach control — always available but styled */}
                                                                <label
                                                                    className="btn btn-sm btn-outline-secondary mb-0"
                                                                    style={{ display: "inline-flex", alignItems: "center", gap: 6 }}
                                                                    title="Attach Files"
                                                                >
                                                                    📎
                                                                    <input type="file" multiple onChange={handleFileUpload} hidden />
                                                                </label>

                                                            </div>

                                                            {/* <div className="ms-auto text-muted small" style={{ fontSize: "12px" }}>
                                Tip: Press <kbd style={{ padding: "2px 6px", borderRadius: 4, background: "#f1f3f5" }}>Ctrl</kbd> + <kbd style={{ padding: "2px 6px", borderRadius: 4, background: "#f1f3f5" }}>Enter</kbd> to submit
                              </div> */}
                                                        </div>

                                                        {/* Editor + bottom row (mentions / attachments) */}
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                position: "relative",
                                                                border: "1px solid #e6e9ee",
                                                                borderRadius: "8px",
                                                                background: "#fff",
                                                                minHeight: "120px",
                                                                padding: "8px",
                                                            }}
                                                        >
                                                            {/* Placeholder overlay (only when empty) */}
                                                            {(!editorRef.current || !editorRef.current.innerText?.trim()) && (
                                                                <div
                                                                    onClick={() => editorRef.current && editorRef.current.focus()}
                                                                    style={{
                                                                        position: "absolute",
                                                                        left: 12,
                                                                        top: 12,
                                                                        pointerEvents: "none",
                                                                        color: "#6c757d",
                                                                        fontSize: 14,
                                                                    }}
                                                                >

                                                                </div>
                                                            )}

                                                            {/* Editable area */}
                                                            <div
                                                                ref={editorRef}
                                                                className="mb-2"
                                                                contentEditable
                                                                suppressContentEditableWarning
                                                                onInput={handleEditorInput}
                                                                onKeyUp={saveCaret}
                                                                onKeyDown={(e) => {
                                                                    // Ctrl+Enter to submit
                                                                    if ((e.ctrlKey || e.metaKey) && e.key === "Enter") {
                                                                        e.preventDefault();
                                                                        addComment();
                                                                    }
                                                                }}
                                                                onClick={saveCaret}
                                                                onPaste={handlePaste}
                                                                style={{
                                                                    minHeight: "80px",
                                                                    outline: "none",
                                                                    textAlign: "left",
                                                                    fontSize: "14px",
                                                                    lineHeight: "1.6",
                                                                    fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
                                                                    overflowY: "auto",
                                                                    whiteSpace: "pre-wrap",
                                                                    wordWrap: "break-word",
                                                                    padding: "6px",
                                                                }}
                                                            ></div>

                                                            {/* Mention chips / attachments row */}
                                                            <div
                                                                className="d-flex gap-2 align-items-center"
                                                                style={{
                                                                    paddingTop: "6px",
                                                                    borderTop: "1px solid #f1f3f5",
                                                                    marginTop: "6px",
                                                                    background: "#fafbfc",
                                                                    borderBottomLeftRadius: 8,
                                                                    borderBottomRightRadius: 8,
                                                                    paddingBottom: 8,
                                                                }}
                                                            >
                                                                {/* Mentionable users (horizontal scroll) */}
                                                                {/* <div className="d-flex gap-2 overflow-auto" style={{ flex: 1 }}>
                                  {mentionableUsers.slice(0, 10).map((u) => {
                                    const photoUrl = u.photoPath ? `${API_BASE_URL}/uploads/${u.photoPath}` : null;
                                    return (
                                      <div
                                        key={u.id}
                                        className="d-flex align-items-center px-2 py-1 rounded"
                                        style={{
                                          background: "#eef2ff",
                                          cursor: "pointer",
                                          whiteSpace: "nowrap",
                                        }}
                                        onClick={() => addMention(u)}
                                      >
                                        <div
                                          className="rounded-circle me-2 d-flex justify-content-center align-items-center"
                                          style={{
                                            width: 26,
                                            height: 26,
                                            overflow: "hidden",
                                            flexShrink: 0,
                                            background: photoUrl ? "transparent" : "#0d6efd",
                                            color: "#fff",
                                            fontWeight: 700,
                                            fontSize: 12,
                                          }}
                                        >
                                          {photoUrl ? (
                                            <img
                                              src={photoUrl}
                                              alt={`${u.firstName} ${u.lastName}`}
                                              style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                              onError={(e) => {
                                                e.currentTarget.onerror = null;
                                                e.currentTarget.src = "/images/avatar-placeholder.png";
                                              }}
                                            />
                                          ) : (
                                            u.firstName.charAt(0).toUpperCase()
                                          )}
                                        </div>
                                        <span style={{ fontSize: 13, fontWeight: 500 }}>
                                          {u.firstName} {u.lastName}
                                        </span>
                                      </div>
                                    );
                                  })}
                                </div> */}

                                                                {/* Attachments preview (small badges) */}
                                                                <div className="d-flex align-items-center">
                                                                    {attachments.length > 0 && (
                                                                        <div className="me-2">
                                                                            {attachments.map((f, i) => (
                                                                                <span
                                                                                    key={i}
                                                                                    className="badge bg-white text-dark me-1 d-inline-flex align-items-center"
                                                                                    style={{
                                                                                        fontSize: "13px",
                                                                                        padding: "6px 8px",
                                                                                        border: "1px solid #e6e9ee",
                                                                                        borderRadius: "12px",
                                                                                        background: "#fff",
                                                                                    }}>
                                                                                    📎 {f.name}
                                                                                    <button
                                                                                        className="btn btn-sm btn-link text-danger p-0 ms-2"
                                                                                        onClick={() => removeAttachment(i)}
                                                                                        style={{ fontSize: "12px" }}
                                                                                        type="button">
                                                                                        ✕
                                                                                    </button>
                                                                                </span>
                                                                            ))}
                                                                        </div>
                                                                    )}


                                                                </div>
                                                            </div>

                                                            {/* Mention suggestions popup (unchanged positioning) */}
                                                            {showSuggestions && filteredUsers.length > 0 && editorRef.current && (
                                                                <div
                                                                    className="position-absolute"
                                                                    style={{
                                                                        zIndex: 1000,
                                                                        top: (editorRef.current?.offsetTop || 0) + (editorRef.current?.offsetHeight || 0) + 6,
                                                                        left: editorRef.current?.offsetLeft || 0,
                                                                    }}
                                                                >
                                                                    <div
                                                                        className="shadow-lg border bg-white rounded-3 overflow-hidden"
                                                                        style={{
                                                                            width: "320px",
                                                                            maxHeight: "260px",
                                                                            overflowY: "auto",
                                                                            boxShadow: "0 6px 20px rgba(0, 0, 0, 0.12)",
                                                                            animation: "fadeInUp 0.16s ease-out",
                                                                        }}
                                                                    >
                                                                        {filteredUsers.map((u, i) => {
                                                                            const photoUrl = u.photoPath ? `${API_BASE_URL}/uploads/${u.photoPath}` : null;
                                                                            return (
                                                                                <button
                                                                                    key={u.id}
                                                                                    type="button"
                                                                                    onClick={() => addMention(u)}
                                                                                    className="d-flex align-items-center w-100 px-3 py-2 border-0 text-start bg-transparent"
                                                                                    style={{
                                                                                        cursor: "pointer",
                                                                                        transition: "all 0.12s ease-in-out",
                                                                                        borderBottom: i < filteredUsers.length - 1 ? "1px solid #f0f0f0" : "none",
                                                                                    }}
                                                                                    onMouseEnter={(e) => {
                                                                                        e.currentTarget.style.background = "#f8f9ff";
                                                                                        e.currentTarget.style.transform = "translateX(2px)";
                                                                                    }}
                                                                                    onMouseLeave={(e) => {
                                                                                        e.currentTarget.style.background = "transparent";
                                                                                        e.currentTarget.style.transform = "translateX(0)";
                                                                                    }}
                                                                                >
                                                                                    <div
                                                                                        className="rounded-circle d-flex justify-content-center align-items-center me-3"
                                                                                        style={{
                                                                                            width: 36,
                                                                                            height: 36,
                                                                                            overflow: "hidden",
                                                                                            flexShrink: 0,
                                                                                            background: photoUrl ? "transparent" : "linear-gradient(135deg, #0d6efd 0%, #5a9eff 100%)",
                                                                                            boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
                                                                                            fontWeight: 600,
                                                                                            fontSize: 15,
                                                                                            color: "#fff",
                                                                                        }}
                                                                                    >
                                                                                        {photoUrl ? (
                                                                                            <img
                                                                                                src={photoUrl}
                                                                                                alt={`${u.firstName} ${u.lastName}`}
                                                                                                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                                                                                onError={(e) => {
                                                                                                    e.currentTarget.onerror = null;
                                                                                                    e.currentTarget.src = "/images/avatar-placeholder.png";
                                                                                                }}
                                                                                            />
                                                                                        ) : (
                                                                                            u.firstName.charAt(0).toUpperCase()
                                                                                        )}
                                                                                    </div>

                                                                                    <div className="flex-grow-1">
                                                                                        <div style={{ fontSize: 14, fontWeight: 600, color: "#212529" }}>
                                                                                            {u.firstName} {u.lastName}
                                                                                        </div>
                                                                                    </div>
                                                                                </button>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                </div>
                                                            )}

                                                        </div>

                                                        {/* Action buttons appear only when editor has content or attachments */}
                                                        {((editorRef.current && editorRef.current.innerText?.trim().length > 0) || attachments.length > 0) && (
                                                            <div className="d-flex justify-content-end gap-2 mt-3">
                                                                <button className="btn btn-outline-secondary btn-sm" onClick={cancelComment}>
                                                                    Cancel
                                                                </button>
                                                                <button className="btn btn-primary btn-sm" onClick={addComment}>
                                                                    Save
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>


                                                {/* 💬 Comments Section (upgraded) */}
                                                <div className="mt-4 col-md-12">
                                                    <h5 className="mb-3">Comments</h5>

                                                    <div
                                                        className="comments-container p-2"
                                                        style={{
                                                            maxHeight: "350px",
                                                            overflowY: "auto",
                                                            paddingRight: "8px",
                                                            border: "1px solid #eee",
                                                            borderRadius: "10px",
                                                            background: "#fbfcfd",
                                                        }}
                                                    >
                                                        {comments.length > 0 ? (
                                                            <div className="d-flex flex-column gap-3">
                                                                {comments.map((c) => {
                                                                    // normalize attachments (if stored as JSON string)
                                                                    let attachmentsArray = [];
                                                                    try {
                                                                        attachmentsArray = typeof c.attachments === "string" ? JSON.parse(c.attachments) : c.attachments || [];
                                                                    } catch (err) {
                                                                        console.error("Invalid attachments JSON", err);
                                                                        attachmentsArray = c.attachments || [];
                                                                    }

                                                                    const commentReplies = c.replies || [];

                                                                    const isOwnComment =
                                                                        c.author &&
                                                                        loggedUserName &&
                                                                        c.author.trim().toLowerCase() === loggedUserName.trim().toLowerCase();


                                                                    // friendly timestamp (fallback to toLocaleString if format fails)
                                                                    // Convert given date string → IST Date object
                                                                    const toIST = (dateString) => {
                                                                        const d = new Date(dateString);
                                                                        // Convert UTC → IST (UTC + 5:30 → 330 minutes)
                                                                        const istOffset = 330; // minutes
                                                                        return new Date(d.getTime() + istOffset * 60 * 1000);
                                                                    };

                                                                    let ts = "";
                                                                    try {
                                                                        ts = c.createdAt
                                                                            ? format(toIST(c.createdAt), "dd MMM yyyy, hh:mm a")
                                                                            : "";
                                                                    } catch (err) {
                                                                        ts = c.createdAt
                                                                            ? toIST(c.createdAt).toLocaleString("en-IN", {
                                                                                timeZone: "Asia/Kolkata",
                                                                            })
                                                                            : "";
                                                                    }

                                                                    const isEdited =
                                                                        (c.updatedAt &&
                                                                            c.createdAt &&
                                                                            new Date(c.updatedAt).getTime() !== new Date(c.createdAt).getTime()) ||
                                                                        Boolean(c.edited);


                                                                    return (
                                                                        <div
                                                                            key={c.id}
                                                                            className="p-3 rounded-3"
                                                                            style={{
                                                                                background: "#ffffff",
                                                                                position: "relative",
                                                                                display: "flex",
                                                                                gap: "14px",
                                                                                alignItems: "flex-start",
                                                                                boxShadow: "0 4px 10px rgba(15, 23, 42, 0.04)",
                                                                                borderLeft: "3px solid rgba(13,110,253,0.14)",
                                                                            }}
                                                                        >
                                                                            {/* Avatar */}
                                                                            <div
                                                                                className="rounded-circle flex-shrink-0 overflow-hidden"
                                                                                style={{
                                                                                    width: 30,
                                                                                    height: 30,
                                                                                    background: "#e9ecef",
                                                                                    borderRadius: "50%",
                                                                                }}
                                                                                title={c.author}
                                                                            >
                                                                                {c.photoPath ? (
                                                                                    <img
                                                                                        src={`${API_BASE_URL}/uploads/${c.photoPath}`}
                                                                                        alt={c.author}
                                                                                        style={{
                                                                                            width: "100%",
                                                                                            height: "100%",
                                                                                            objectFit: "cover"
                                                                                        }}
                                                                                        onError={(e) => {
                                                                                            e.target.onerror = null;
                                                                                            e.target.src = "/default-avatar.png";
                                                                                        }}
                                                                                    />
                                                                                ) : (
                                                                                    <div
                                                                                        className="d-flex justify-content-center align-items-center"
                                                                                        style={{
                                                                                            width: "100%",
                                                                                            height: "100%",
                                                                                            background: "#0d6efd",
                                                                                            color: "#fff",
                                                                                            fontWeight: "bold",
                                                                                            fontSize: 14,
                                                                                        }}
                                                                                    >
                                                                                        {c.author ? c.author.charAt(0).toUpperCase() : "U"}
                                                                                    </div>
                                                                                )}
                                                                            </div>


                                                                            {/* Content */}
                                                                            <div className="flex-grow-1 d-flex flex-column" style={{ minWidth: 0 }}>
                                                                                <div className="d-flex justify-content-between align-items-start mb-1">
                                                                                    <div>
                                                                                        <strong style={{ fontSize: 15 }}>{c.author || "Unknown"}</strong>
                                                                                        <div style={{ fontSize: 12, color: "#6c757d", marginTop: 2 }}>
                                                                                            {ts} {isEdited && <span className="badge bg-light text-muted ms-2" style={{ fontSize: 11 }}>edited</span>}
                                                                                        </div>
                                                                                    </div>


                                                                                </div>




                                                                                {/* Edit mode */}
                                                                                {editingCommentId === c.id ? (
                                                                                    <div className="card shadow-sm border-0 task-section task-section--comments edit-card">
                                                                                        <div className="card-body col-md-12 p-3">

                                                                                            {/* Toolbar */}
                                                                                            <div
                                                                                                className="d-flex gap-2 flex-wrap align-items-center mb-2"
                                                                                                style={{ borderBottom: "1px solid #eee", paddingBottom: "8px" }}
                                                                                            >
                                                                                                <div className="d-flex gap-1" style={{ alignItems: "center" }}>
                                                                                                    <button type="button" className="btn btn-sm btn-outline-secondary" title="Bold (Ctrl+B)" onClick={() => document.execCommand("bold")}><b>B</b></button>
                                                                                                    <button type="button" className="btn btn-sm btn-outline-secondary" title="Italic (Ctrl+I)" onClick={() => document.execCommand("italic")}><i>I</i></button>
                                                                                                    <button type="button" className="btn btn-sm btn-outline-secondary" title="Underline (Ctrl+U)" onClick={() => document.execCommand("underline")}><u>U</u></button>
                                                                                                    <button
                                                                                                        type="button"
                                                                                                        className="btn btn-sm btn-outline-secondary"
                                                                                                        title="Numbered List"
                                                                                                        onClick={() => document.execCommand("insertOrderedList")}
                                                                                                    >
                                                                                                        <i className="bi bi-list-ol"></i>
                                                                                                    </button>

                                                                                                    <div style={{ position: "relative" }}>
                                                                                                        <button
                                                                                                            type="button"
                                                                                                            className="btn btn-sm btn-outline-secondary"
                                                                                                            title="Text Color"
                                                                                                            onClick={() => document.getElementById("colorPickerInput").click()}
                                                                                                        >
                                                                                                            <i className="bi bi-palette"></i>
                                                                                                        </button>

                                                                                                        <input
                                                                                                            type="color"
                                                                                                            id="colorPickerInput"
                                                                                                            style={{ visibility: "hidden", position: "absolute" }}
                                                                                                            onChange={(e) => document.execCommand("foreColor", false, e.target.value)}
                                                                                                        />
                                                                                                    </div>


                                                                                                    <div style={{ position: "relative" }}>
                                                                                                        <button
                                                                                                            type="button"
                                                                                                            className="btn btn-sm btn-outline-secondary"
                                                                                                            title="Highlight Color"
                                                                                                            onClick={() => document.getElementById("highlightPickerInput").click()}
                                                                                                        >
                                                                                                            <i className="bi bi-highlighter"></i>
                                                                                                        </button>

                                                                                                        <input
                                                                                                            type="color"
                                                                                                            id="highlightPickerInput"
                                                                                                            style={{ visibility: "hidden", position: "absolute" }}
                                                                                                            onChange={(e) =>
                                                                                                                document.execCommand("hiliteColor", false, e.target.value)
                                                                                                            }
                                                                                                        />
                                                                                                    </div>

                                                                                                    <button type="button" className="btn btn-sm btn-outline-secondary" title="Insert link" onClick={() => { const url = prompt("Enter link URL:"); if (url) document.execCommand("createLink", false, url); }}>🔗</button>
                                                                                                    <label
                                                                                                        className="btn btn-sm btn-outline-secondary mb-0"
                                                                                                        style={{ display: "inline-flex", alignItems: "center", gap: 6 }}
                                                                                                        title="Attach Files"
                                                                                                    >
                                                                                                        📎
                                                                                                        <input
                                                                                                            type="file"
                                                                                                            multiple
                                                                                                            onChange={(ev) => {
                                                                                                                const files = Array.from(ev.target.files || []);
                                                                                                                setEditAttachments(prev => [
                                                                                                                    ...(prev || []),
                                                                                                                    ...files.map(f => ({ name: f.name, file: f }))
                                                                                                                ]);
                                                                                                            }}
                                                                                                            hidden
                                                                                                        />
                                                                                                    </label>

                                                                                                </div>
                                                                                            </div>

                                                                                            {/* Editor container */}
                                                                                            <div style={{ display: "flex", flexDirection: "column", position: "relative", border: "1px solid #e6e9ee", borderRadius: "8px", background: "#fbfbfd", minHeight: "120px", padding: "8px" }}>
                                                                                                {/* contentEditable */}
                                                                                                <div
                                                                                                    ref={editRef}
                                                                                                    className="mb-2 reply-input"
                                                                                                    contentEditable
                                                                                                    suppressContentEditableWarning
                                                                                                    onInput={handleEditInput}
                                                                                                    onKeyUp={saveCaret}
                                                                                                    onKeyDown={(e) => {
                                                                                                        if ((e.ctrlKey || e.metaKey) && e.key === "Enter") {
                                                                                                            e.preventDefault();
                                                                                                            saveEdit(c.id);
                                                                                                        }
                                                                                                        // optional: Esc to cancel
                                                                                                        if (e.key === "Escape") {
                                                                                                            setEditingCommentId(null);
                                                                                                        }
                                                                                                    }}
                                                                                                    onClick={saveCaret}
                                                                                                    onPaste={handleEditPaste}
                                                                                                    style={{
                                                                                                        minHeight: "80px",
                                                                                                        outline: "none",
                                                                                                        textAlign: "left",
                                                                                                        fontSize: "14px",
                                                                                                        lineHeight: "1.6",
                                                                                                        fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
                                                                                                        overflowY: "auto",
                                                                                                        whiteSpace: "pre-wrap",
                                                                                                        wordWrap: "break-word",
                                                                                                        padding: "6px",
                                                                                                        borderRadius: 6,
                                                                                                        background: "transparent",
                                                                                                    }}
                                                                                                    role="textbox"
                                                                                                    aria-label="Edit comment editor"
                                                                                                >
                                                                                                    {/* Keep showing initial text as HTML — but we set it in effect (not as children) */}
                                                                                                </div>

                                                                                                {/* Placeholder */}
                                                                                                <div
                                                                                                    className="reply-placeholder"
                                                                                                    onClick={() => editRef.current && editRef.current.focus()}
                                                                                                    style={{ position: "absolute", left: 16, top: 14, pointerEvents: "none", color: "#6c757d", fontSize: 14 }}
                                                                                                >
                                                                                                    edit comment...
                                                                                                </div>

                                                                                                {/* Attachments + mention chips area */}

                                                                                                <div
                                                                                                    className="d-flex gap-2 align-items-center"
                                                                                                    style={{
                                                                                                        paddingTop: "6px",
                                                                                                        borderTop: "1px solid #f1f3f5",
                                                                                                        marginTop: "6px",
                                                                                                        background: "#fafbfc",
                                                                                                        borderBottomLeftRadius: 8,
                                                                                                        borderBottomRightRadius: 8,
                                                                                                        paddingBottom: 8,
                                                                                                    }}
                                                                                                >
                                                                                                    <div className="d-flex align-items-center">
                                                                                                        {editAttachments && editAttachments.length > 0 && (
                                                                                                            <div className="me-2 d-flex flex-wrap">

                                                                                                                {editAttachments
                                                                                                                    .filter((f) => !/\.(jpe?g|jpeg|png|gif|bmp|webp)$/i.test(f.name || ""))
                                                                                                                    .map((f, i) => (
                                                                                                                        <div
                                                                                                                            key={i}
                                                                                                                            className="me-1 mb-1 d-inline-flex align-items-center"
                                                                                                                            style={{ fontSize: 13 }}
                                                                                                                        >
                                                                                                                            {/* Non-image file badge */}
                                                                                                                            <a
                                                                                                                                href={f.url || f.base64 || "#"}
                                                                                                                                target="_blank"
                                                                                                                                rel="noreferrer"
                                                                                                                                className="badge bg-white text-dark d-inline-flex align-items-center"
                                                                                                                                style={{
                                                                                                                                    padding: "6px 8px",
                                                                                                                                    border: "1px solid #e6e9ee",
                                                                                                                                    borderRadius: 12,
                                                                                                                                    textDecoration: "none",
                                                                                                                                }}
                                                                                                                                title={f.name}
                                                                                                                            >
                                                                                                                                📎 {f.name}
                                                                                                                            </a>

                                                                                                                            <button
                                                                                                                                type="button"
                                                                                                                                className="btn btn-sm btn-link text-danger p-0 ms-2"
                                                                                                                                onClick={() => {
                                                                                                                                    setEditAttachments((prev) => {
                                                                                                                                        const copy = [...prev];
                                                                                                                                        const removed = copy.splice(i, 1)[0]; // remove item

                                                                                                                                        // ---- SAFE REMOVE FROM HTML ----
                                                                                                                                        if (editRef.current) {
                                                                                                                                            const editor = editRef.current;
                                                                                                                                            const temp = document.createElement("div");
                                                                                                                                            temp.innerHTML = editor.innerHTML;

                                                                                                                                            // Remove image tags that match the removed attachment (if any)
                                                                                                                                            const imgs = temp.querySelectorAll("img");
                                                                                                                                            imgs.forEach((img) => {
                                                                                                                                                if (removed.base64 && img.src === removed.base64) {
                                                                                                                                                    img.remove();
                                                                                                                                                }
                                                                                                                                            });

                                                                                                                                            // Remove file badges / links that include the file name (non-image)
                                                                                                                                            const possibleEls = temp.querySelectorAll("a, span, div");
                                                                                                                                            possibleEls.forEach((el) => {
                                                                                                                                                if (
                                                                                                                                                    removed.name &&
                                                                                                                                                    el.textContent &&
                                                                                                                                                    el.textContent.trim().includes(removed.name)
                                                                                                                                                ) {
                                                                                                                                                    el.remove();
                                                                                                                                                }
                                                                                                                                            });

                                                                                                                                            editor.innerHTML = temp.innerHTML;
                                                                                                                                        }

                                                                                                                                        return copy;
                                                                                                                                    });
                                                                                                                                }}
                                                                                                                            >
                                                                                                                                X
                                                                                                                            </button>
                                                                                                                        </div>
                                                                                                                    ))}
                                                                                                            </div>
                                                                                                        )}
                                                                                                    </div>
                                                                                                </div>


                                                                                                {/* Mention suggestions popup (if you maintain filteredUsers & replyShowSuggestions state) */}
                                                                                                {replyShowSuggestions && filteredUsers.length > 0 && editRef.current && (
                                                                                                    <div className="position-absolute" style={{ zIndex: 1000, top: (editRef.current?.offsetTop || 0) + (editRef.current?.offsetHeight || 0) + 6, left: editRef.current?.offsetLeft || 0 }}>
                                                                                                        <div className="shadow-lg border bg-white rounded-3 overflow-hidden" style={{ width: "320px", maxHeight: "260px", overflowY: "auto", boxShadow: "0 6px 20px rgba(0,0,0,0.12)" }}>
                                                                                                            {filteredUsers.map((u, i) => (
                                                                                                                <button key={u.id} type="button" onClick={() => insertMentionAtCaretInEdit(u)}
                                                                                                                    className="d-flex align-items-center w-100 px-3 py-2 border-0 text-start bg-transparent" style={{ cursor: "pointer", transition: "all 0.12s ease-in-out", borderBottom: i < filteredUsers.length - 1 ? "1px solid #f0f0f0" : "none" }}>
                                                                                                                    <div className="rounded-circle d-flex justify-content-center align-items-center me-3" style={{ width: 36, height: 36, overflow: "hidden", flexShrink: 0, background: "#0d6efd", color: "#fff", fontWeight: 600, fontSize: 15 }}>
                                                                                                                        {u.firstName.charAt(0).toUpperCase()}
                                                                                                                    </div>
                                                                                                                    <div className="flex-grow-1">
                                                                                                                        <div style={{ fontSize: 14, fontWeight: 600, color: "#212529" }}>{u.firstName} {u.lastName}</div>
                                                                                                                    </div>
                                                                                                                </button>
                                                                                                            ))}
                                                                                                        </div>
                                                                                                    </div>
                                                                                                )}
                                                                                            </div>

                                                                                            {/* Actions */}
                                                                                            <div className="d-flex justify-content-end gap-2 mt-3">
                                                                                                <button
                                                                                                    className="btn btn-outline-secondary btn-sm"
                                                                                                    onClick={() => {
                                                                                                        setEditingCommentId(null);
                                                                                                        setEditContent("");
                                                                                                        setEditAttachments([]);
                                                                                                        if (editRef.current) {
                                                                                                            editRef.current.innerHTML = "";
                                                                                                            editRef.current.setAttribute("data-filled", "false");
                                                                                                        }
                                                                                                    }}
                                                                                                >
                                                                                                    Cancel
                                                                                                </button>

                                                                                                <button
                                                                                                    className="btn btn-primary btn-sm"
                                                                                                    onClick={() => saveEdit(c.id)}
                                                                                                >
                                                                                                    Save
                                                                                                </button>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                ) : (
                                                                                    <div>
                                                                                        {/* inside your comment render */}
                                                                                        <div
                                                                                            className="comment-body mt-2"
                                                                                            dangerouslySetInnerHTML={{
                                                                                                __html: `
                                                                                                    <style>
                                                                                                        .comment-body img {
                                                                                                        max-width: 100%;
                                                                                                        height: auto;
                                                                                                        display: block;
                                                                                                        }
                                                                                                    </style>
                                                                                                    ${c.html}
                                                                                                    `
                                                                                            }}
                                                                                            style={{
                                                                                                fontSize: 14,
                                                                                                lineHeight: "1.4",
                                                                                                cursor: "default",
                                                                                                overflowWrap: "break-word",
                                                                                                wordBreak: "break-word",
                                                                                                whiteSpace: "normal",
                                                                                            }}
                                                                                            onClick={(e) => handleCommentImageClick(e, c)}
                                                                                        ></div>



                                                                                        {/* Attachments grid */}
                                                                                        {attachmentsArray.length > 0 && (
                                                                                            <div className="d-flex flex-wrap gap-2 mb-2">

                                                                                                {attachmentsArray
                                                                                                    .filter((file) => !/\.(jpe?g|png|gif|bmp|webp)$/i.test(file.name || "")) // 🚫 remove images
                                                                                                    .map((file, idx) => (
                                                                                                        <a
                                                                                                            key={idx}
                                                                                                            href={file.url || file.base64 || "#"}
                                                                                                            target="_blank"
                                                                                                            rel="noreferrer"
                                                                                                            className="badge bg-white text-dark d-inline-flex align-items-center"
                                                                                                            style={{
                                                                                                                fontSize: 13,
                                                                                                                padding: "8px 10px",
                                                                                                                borderRadius: 10,
                                                                                                                border: "1px solid #f0f0f0",
                                                                                                                boxShadow: "0 2px 6px rgba(0,0,0,0.03)",
                                                                                                                textDecoration: "none",
                                                                                                            }}
                                                                                                            title={file.name}
                                                                                                        >
                                                                                                            📎 {file.name}
                                                                                                        </a>
                                                                                                    ))}
                                                                                            </div>
                                                                                        )}

                                                                                    </div>
                                                                                )}


                                                                                {/* Reply input — drop this in where you render comment replies */}
                                                                                {replyToCommentId === c.id && (
                                                                                    <div className="card shadow-sm border-0 task-section task-section--comments reply-card">
                                                                                        <div className="card-body col-md-12 p-3">

                                                                                            {/* Toolbar */}
                                                                                            <div
                                                                                                className="d-flex gap-2 flex-wrap align-items-center mb-2"
                                                                                                style={{ borderBottom: "1px solid #eee", paddingBottom: "8px" }}
                                                                                            >
                                                                                                <div className="d-flex gap-1" style={{ alignItems: "center" }}>
                                                                                                    <button type="button" className="btn btn-sm btn-outline-secondary" title="Bold (Ctrl+B)" onClick={() => document.execCommand("bold")}><b>B</b></button>
                                                                                                    <button type="button" className="btn btn-sm btn-outline-secondary" title="Italic (Ctrl+I)" onClick={() => document.execCommand("italic")}><i>I</i></button>
                                                                                                    <button type="button" className="btn btn-sm btn-outline-secondary" title="Underline (Ctrl+U)" onClick={() => document.execCommand("underline")}><u>U</u></button>
                                                                                                    <button
                                                                                                        type="button"
                                                                                                        className="btn btn-sm btn-outline-secondary"
                                                                                                        title="Numbered List"
                                                                                                        onClick={() => document.execCommand("insertOrderedList")}
                                                                                                    >
                                                                                                        <i className="bi bi-list-ol"></i>
                                                                                                    </button>

                                                                                                    <div style={{ position: "relative" }}>
                                                                                                        <button
                                                                                                            type="button"
                                                                                                            className="btn btn-sm btn-outline-secondary"
                                                                                                            title="Text Color"
                                                                                                            onClick={() => document.getElementById("colorPickerInput").click()}
                                                                                                        >
                                                                                                            <i className="bi bi-palette"></i>
                                                                                                        </button>

                                                                                                        <input
                                                                                                            type="color"
                                                                                                            id="colorPickerInput"
                                                                                                            style={{ visibility: "hidden", position: "absolute" }}
                                                                                                            onChange={(e) => document.execCommand("foreColor", false, e.target.value)}
                                                                                                        />
                                                                                                    </div>


                                                                                                    <div style={{ position: "relative" }}>
                                                                                                        <button
                                                                                                            type="button"
                                                                                                            className="btn btn-sm btn-outline-secondary"
                                                                                                            title="Highlight Color"
                                                                                                            onClick={() => document.getElementById("highlightPickerInput").click()}
                                                                                                        >
                                                                                                            <i className="bi bi-highlighter"></i>
                                                                                                        </button>

                                                                                                        <input
                                                                                                            type="color"
                                                                                                            id="highlightPickerInput"
                                                                                                            style={{ visibility: "hidden", position: "absolute" }}
                                                                                                            onChange={(e) =>
                                                                                                                document.execCommand("hiliteColor", false, e.target.value)
                                                                                                            }
                                                                                                        />
                                                                                                    </div>
                                                                                                    <button type="button" className="btn btn-sm btn-outline-secondary" title="Insert link" onClick={() => { const url = prompt("Enter link URL:"); if (url) document.execCommand("createLink", false, url); }}>🔗</button>
                                                                                                    <label className="btn btn-sm btn-outline-secondary mb-0" style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                                                                                                        📎 Attach
                                                                                                        <input type="file" multiple onChange={(ev) => {
                                                                                                            const files = Array.from(ev.target.files || []);
                                                                                                            // convert or directly store files as you need
                                                                                                            setReplyAttachments(prev => [...(prev || []), ...files.map(f => ({ name: f.name, file: f }))]);
                                                                                                        }} hidden />
                                                                                                    </label>
                                                                                                </div>
                                                                                            </div>

                                                                                            {/* Editor + bottom row */}
                                                                                            <div style={{ display: "flex", flexDirection: "column", position: "relative", border: "1px solid #e6e9ee", borderRadius: "8px", background: "#fff", minHeight: "120px", padding: "8px" }}>


                                                                                                {/* Editable area */}
                                                                                                <div
                                                                                                    ref={replyEditorRef}
                                                                                                    className="mb-2 reply-input"
                                                                                                    contentEditable
                                                                                                    suppressContentEditableWarning
                                                                                                    onInput={handleReplyEditorInput}
                                                                                                    onKeyUp={saveCaret}
                                                                                                    onKeyDown={(e) => {
                                                                                                        if ((e.ctrlKey || e.metaKey) && e.key === "Enter") {
                                                                                                            e.preventDefault();
                                                                                                            // call your submit handler
                                                                                                            if (typeof submitReply === "function") submitReply(c.id);
                                                                                                        }
                                                                                                    }}
                                                                                                    onClick={saveCaret}
                                                                                                    onPaste={handleReplyPaste}
                                                                                                    style={{
                                                                                                        minHeight: "80px",
                                                                                                        outline: "none",
                                                                                                        textAlign: "left",
                                                                                                        fontSize: "14px",
                                                                                                        lineHeight: "1.6",
                                                                                                        fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
                                                                                                        overflowY: "auto",
                                                                                                        whiteSpace: "pre-wrap",
                                                                                                        wordWrap: "break-word",
                                                                                                        padding: "6px",
                                                                                                    }}
                                                                                                    role="textbox"
                                                                                                    aria-label="Reply editor"
                                                                                                ></div>

                                                                                                {/* Placeholder (rendered AFTER contentEditable so CSS selector is simple) */}
                                                                                                <div
                                                                                                    className="reply-placeholder"
                                                                                                    onClick={() => replyEditorRef.current && replyEditorRef.current.focus()}
                                                                                                    style={{ position: "absolute", left: 12, top: 12, pointerEvents: "none", color: "#6c757d", fontSize: 14 }}
                                                                                                >
                                                                                                    reply...
                                                                                                </div>

                                                                                                {/* Mention chips / attachments row */}
                                                                                                <div className="d-flex gap-2 align-items-center" style={{ paddingTop: "6px", borderTop: "1px solid #f1f3f5", marginTop: "6px", background: "#fafbfc", borderBottomLeftRadius: 8, borderBottomRightRadius: 8, paddingBottom: 8 }}>
                                                                                                    {/* <div className="d-flex gap-2 overflow-auto" style={{ flex: 1 }}>
                                                    {mentionableUsers.slice(0, 10).map((u) => {
                                                      const photoUrl = u.photoPath ? `${API_BASE_URL}/uploads/${u.photoPath}` : null;
                                                      return (
                                                        <div key={u.id} className="d-flex align-items-center px-2 py-1 rounded" style={{ background: "#eef2ff", cursor: "pointer", whiteSpace: "nowrap" }} onClick={() => {
                                                          
                                                          if (!replyEditorRef.current) return;
                                                          const mention = `@${u.firstName} ${u.lastName} `;
                                                          document.execCommand("insertText", false, mention);
                                                          handleReplyEditorInput();
                                                        }}>
                                                          <div className="rounded-circle me-2 d-flex justify-content-center align-items-center" style={{ width: 26, height: 26, overflow: "hidden", flexShrink: 0, background: photoUrl ? "transparent" : "#0d6efd", color: "#fff", fontWeight: 700, fontSize: 12 }}>
                                                            {photoUrl ? <img src={photoUrl} alt={`${u.firstName} ${u.lastName}`} style={{ width: "100%", height: "100%", objectFit: "cover" }} onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = "/images/avatar-placeholder.png"; }} /> : u.firstName.charAt(0).toUpperCase()}
                                                          </div>
                                                          <span style={{ fontSize: 13, fontWeight: 500 }}>{u.firstName} {u.lastName}</span>
                                                        </div>
                                                      );
                                                    })}
                                                  </div> */}

                                                                                                    {/* Attachments preview */}
                                                                                                    <div className="d-flex align-items-center">
                                                                                                        {replyAttachments && replyAttachments.length > 0 && (
                                                                                                            <div className="me-2">
                                                                                                                {replyAttachments.map((f, i) => (
                                                                                                                    <span key={i} className="badge bg-white text-dark me-1 d-inline-flex align-items-center" style={{ fontSize: "13px", padding: "6px 8px", border: "1px solid #e6e9ee", borderRadius: "12px", background: "#fff" }}>
                                                                                                                        📎 {f.name}
                                                                                                                        <button className="btn btn-sm btn-link text-danger p-0 ms-2" onClick={() => {
                                                                                                                            const copy = [...replyAttachments];
                                                                                                                            copy.splice(i, 1);
                                                                                                                            setReplyAttachments(copy);
                                                                                                                        }} style={{ fontSize: "12px" }} type="button">✕</button>
                                                                                                                    </span>
                                                                                                                ))}
                                                                                                            </div>
                                                                                                        )}


                                                                                                    </div>
                                                                                                </div>

                                                                                                {/* Mention suggestions popup (optional if you have showSuggestions/filteredUsers logic) */}
                                                                                                {replyShowSuggestions && filteredUsers.length > 0 && replyEditorRef.current && (
                                                                                                    <div className="position-absolute" style={{ zIndex: 1000, top: (replyEditorRef.current?.offsetTop || 0) + (replyEditorRef.current?.offsetHeight || 0) + 6, left: replyEditorRef.current?.offsetLeft || 0 }}>
                                                                                                        <div className="shadow-lg border bg-white rounded-3 overflow-hidden" style={{ width: "320px", maxHeight: "260px", overflowY: "auto", boxShadow: "0 6px 20px rgba(0,0,0,0.12)" }}>
                                                                                                            {filteredUsers.map((u, i) => (
                                                                                                                <button key={u.id} type="button" onClick={() => insertMentionAtCaret(u)}

                                                                                                                    className="d-flex align-items-center w-100 px-3 py-2 border-0 text-start bg-transparent" style={{ cursor: "pointer", transition: "all 0.12s ease-in-out", borderBottom: i < filteredUsers.length - 1 ? "1px solid #f0f0f0" : "none" }}>
                                                                                                                    <div className="rounded-circle d-flex justify-content-center align-items-center me-3" style={{ width: 36, height: 36, overflow: "hidden", flexShrink: 0, background: "#0d6efd", color: "#fff", fontWeight: 600, fontSize: 15 }}>
                                                                                                                        {u.firstName.charAt(0).toUpperCase()}
                                                                                                                    </div>
                                                                                                                    <div className="flex-grow-1">
                                                                                                                        <div style={{ fontSize: 14, fontWeight: 600, color: "#212529" }}>{u.firstName} {u.lastName}</div>
                                                                                                                    </div>
                                                                                                                </button>
                                                                                                            ))}
                                                                                                        </div>
                                                                                                    </div>
                                                                                                )}

                                                                                            </div>

                                                                                            {/* Actions — visible only when editor has content or attachments */}
                                                                                            {replyToCommentId === c.id && (
                                                                                                <div className="d-flex justify-content-end gap-2 mt-3">
                                                                                                    <button
                                                                                                        className="btn btn-outline-secondary btn-sm"
                                                                                                        onClick={() => {
                                                                                                            setReplyToCommentId(null);
                                                                                                            setReplyAttachments([]);
                                                                                                            if (replyEditorRef.current) {
                                                                                                                replyEditorRef.current.innerHTML = "";
                                                                                                                replyEditorRef.current.setAttribute("data-filled", "false");
                                                                                                            }
                                                                                                        }}
                                                                                                    >
                                                                                                        Cancel
                                                                                                    </button>

                                                                                                    <button
                                                                                                        className="btn btn-primary btn-sm"
                                                                                                        onClick={() => submitReply(c.id)}
                                                                                                    >
                                                                                                        save
                                                                                                    </button>
                                                                                                </div>
                                                                                            )}


                                                                                        </div>
                                                                                    </div>
                                                                                )}

                                                                                {/* --- Icon action row: Reply / Edit / Delete (moved BELOW content) --- */}
                                                                                {editingCommentId !== c.id && (
                                                                                    <div
                                                                                        className="d-flex align-items-center gap-2 mt-2 pt-2"
                                                                                        style={{
                                                                                            borderTop: "1px solid #eef2f6",
                                                                                            marginTop: 8,
                                                                                            paddingTop: 8,
                                                                                            justifyContent: "flex-start",
                                                                                        }}
                                                                                    >
                                                                                        {/* Reply icon */}
                                                                                        {/* <button
                                                                                            type="button"
                                                                                            className="btn btn-sm btn-light"
                                                                                            title="Reply"
                                                                                            onClick={() => {
                                                                                                setReplyToCommentId(c.id);
                                                                                                setReplyContent("");
                                                                                                // optional: scroll into view
                                                                                                // document.getElementById(`comment-${c.id}`)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                                                                            }}
                                                                                            aria-label="Reply"
                                                                                            style={{
                                                                                                width: 36,
                                                                                                height: 36,
                                                                                                padding: 0,
                                                                                                display: "inline-flex",
                                                                                                alignItems: "center",
                                                                                                justifyContent: "center",
                                                                                                borderRadius: 8,
                                                                                            }}
                                                                                        >
                                                                                            <i className="bi bi-chat-left-text-fill" style={{ fontSize: 12 }}></i>
                                                                                        </button> */}



                                                                                        {/* Edit icon */}
                                                                                        {isOwnComment && (
                                                                                            <button
                                                                                                type="button"
                                                                                                className="btn btn-sm btn-light"
                                                                                                title="Edit"
                                                                                                // Replace the existing onClick for the Edit button with this
                                                                                                onClick={() => {
                                                                                                    setEditingCommentId(c.id);
                                                                                                    setEditContent(c.text || "");

                                                                                                    // Normalize attachments coming from server which may be:
                                                                                                    // - already an array (parsed)
                                                                                                    // - or a JSON string (e.g. "[{...}]")
                                                                                                    let incoming = [];
                                                                                                    try {
                                                                                                        if (Array.isArray(c.attachments)) {
                                                                                                            incoming = c.attachments;
                                                                                                        } else if (typeof c.attachments === "string" && c.attachments.trim()) {
                                                                                                            incoming = JSON.parse(c.attachments);
                                                                                                        } else {
                                                                                                            incoming = [];
                                                                                                        }
                                                                                                    } catch (err) {
                                                                                                        console.warn("Failed to parse comment.attachments, falling back to empty", err);
                                                                                                        incoming = [];
                                                                                                    }

                                                                                                    // Normalize to a consistent shape your edit UI expects: { id?, name?, url?, base64?, file? }
                                                                                                    const normalized = (incoming || []).map((a) => {
                                                                                                        if (!a) return null;
                                                                                                        // if the server already returned a url or id (existing attachment)
                                                                                                        if (a.url || a.id) {
                                                                                                            return {
                                                                                                                id: a.id || null,
                                                                                                                name: a.name || (a.url ? a.url.split("/").pop() : "attachment"),
                                                                                                                url: a.url || null,
                                                                                                            };
                                                                                                        }
                                                                                                        // if server returned base64 inline
                                                                                                        if (a.base64) {
                                                                                                            return {
                                                                                                                id: a.id || null,
                                                                                                                name: a.name || "attachment",
                                                                                                                base64: a.base64,
                                                                                                            };
                                                                                                        }
                                                                                                        // fallback: copy whatever fields exist
                                                                                                        return {
                                                                                                            id: a.id || null,
                                                                                                            name: a.name || a.fileName || "attachment",
                                                                                                            url: a.url || null,
                                                                                                            base64: a.base64 || null,
                                                                                                        };
                                                                                                    }).filter(Boolean);

                                                                                                    // THIS IS THE KEY: populate editAttachments (edit UI reads this)
                                                                                                    setEditAttachments(normalized);

                                                                                                    // Put the comment text into the contentEditable and focus
                                                                                                    // helper: move caret to end of contentEditable
                                                                                                    function moveCaretToEnd(el) {
                                                                                                        el = el || editRef.current;
                                                                                                        if (!el) return;
                                                                                                        el.focus();
                                                                                                        if (typeof window.getSelection !== "undefined"
                                                                                                            && typeof document.createRange !== "undefined") {
                                                                                                            const range = document.createRange();
                                                                                                            range.selectNodeContents(el);
                                                                                                            range.collapse(false);
                                                                                                            const sel = window.getSelection();
                                                                                                            sel.removeAllRanges();
                                                                                                            sel.addRange(range);
                                                                                                        } else if (document.body.createTextRange) { // IE fallback
                                                                                                            const textRange = document.body.createTextRange();
                                                                                                            textRange.moveToElementText(el);
                                                                                                            textRange.collapse(false);
                                                                                                            textRange.select();
                                                                                                        }
                                                                                                    }

                                                                                                    setTimeout(() => {
                                                                                                        if (!editRef.current) return;
                                                                                                        // Prefer server-side HTML if provided
                                                                                                        const serverHtml = c.html || ""; // `c.html` should contain your saved innerHTML (with <img src="data:...">)
                                                                                                        if (serverHtml && serverHtml.trim()) {
                                                                                                            // Put the raw HTML into editor (preserves images and formatting)
                                                                                                            editRef.current.innerHTML = serverHtml;
                                                                                                            editRef.current.setAttribute("data-filled", "true");
                                                                                                        } else if (c.text) {
                                                                                                            // If only plain text is available, set textContent (not innerText) to avoid layout quirks
                                                                                                            editRef.current.textContent = c.text;
                                                                                                            editRef.current.setAttribute("data-filled", "true");

                                                                                                            // If there are editAttachments with base64 images but serverHtml didn't include them,
                                                                                                            // we append them after the text so user still sees attachments.
                                                                                                            if (Array.isArray(normalized) && normalized.length) {
                                                                                                                normalized.forEach((att) => {
                                                                                                                    if (att.base64 && /^data:image\/(png|jpe?g|gif|webp);base64,/.test(att.base64)) {
                                                                                                                        const img = document.createElement("img");
                                                                                                                        img.src = att.base64;
                                                                                                                        img.alt = att.name || "attachment";
                                                                                                                        img.style.maxWidth = "300px";
                                                                                                                        img.style.maxHeight = "180px";
                                                                                                                        img.style.display = "block";
                                                                                                                        img.style.marginTop = "8px";
                                                                                                                        editRef.current.appendChild(img);
                                                                                                                    } else if (att.url && /\.(jpe?g|png|gif|webp|bmp)$/i.test(att.name || att.url)) {
                                                                                                                        const img = document.createElement("img");
                                                                                                                        img.src = att.url;
                                                                                                                        img.alt = att.name || "attachment";
                                                                                                                        img.style.maxWidth = "300px";
                                                                                                                        img.style.maxHeight = "180px";
                                                                                                                        img.style.display = "block";
                                                                                                                        img.style.marginTop = "8px";
                                                                                                                        editRef.current.appendChild(img);
                                                                                                                    } else if (att.url || att.name) {
                                                                                                                        // render file badge for non-images
                                                                                                                        const span = document.createElement("a");
                                                                                                                        span.href = att.url || "#";
                                                                                                                        span.textContent = "📎 " + (att.name || att.url.split("/").pop());
                                                                                                                        span.target = "_blank";
                                                                                                                        span.rel = "noreferrer";
                                                                                                                        span.style.display = "inline-block";
                                                                                                                        span.style.margin = "6px 0";
                                                                                                                        editRef.current.appendChild(span);
                                                                                                                    }
                                                                                                                });
                                                                                                            }
                                                                                                        } else {
                                                                                                            editRef.current.innerHTML = "";
                                                                                                            editRef.current.setAttribute("data-filled", "false");
                                                                                                        }

                                                                                                        // move caret to end and focus
                                                                                                        moveCaretToEnd(editRef.current);
                                                                                                    }, 120);

                                                                                                }}



                                                                                                aria-label="Edit"
                                                                                                style={{
                                                                                                    width: 36,
                                                                                                    height: 36,
                                                                                                    padding: 0,
                                                                                                    display: "inline-flex",
                                                                                                    alignItems: "center",
                                                                                                    justifyContent: "center",
                                                                                                    borderRadius: 8,
                                                                                                }}
                                                                                            >
                                                                                                <i className="bi bi-pencil-fill" style={{ fontSize: 11 }}></i>
                                                                                            </button>
                                                                                        )}
                                                                                        {/* Delete icon (owner only) */}
                                                                                        {isOwnComment && (
                                                                                            <button
                                                                                                type="button"
                                                                                                className="btn btn-sm btn-light "
                                                                                                title="Delete"
                                                                                                onClick={() => deleteComment(c.id)}
                                                                                                aria-label="Delete"
                                                                                                style={{
                                                                                                    width: 36,
                                                                                                    height: 36,
                                                                                                    padding: 0,
                                                                                                    display: "inline-flex",
                                                                                                    alignItems: "center",
                                                                                                    justifyContent: "center",
                                                                                                    borderRadius: 8,
                                                                                                }}
                                                                                            >
                                                                                                <i className="bi bi-trash-fill" style={{ fontSize: 11 }}></i>
                                                                                            </button>
                                                                                        )}
                                                                                    </div>
                                                                                )}

                                                                                {/* Replies */}
                                                                                {c.replies && c.replies.length > 0 && (
                                                                                    <div className="ms-4 mt-3 d-flex flex-column gap-2">
                                                                                        {c.replies.map((r) => {
                                                                                            const atts = parseAttachmentsField(r);
                                                                                            const isEditing = editingReplyId === r.id;

                                                                                            const isOwnReply =
                                                                                                r.author &&
                                                                                                loggedUserName &&
                                                                                                r.author.trim().toLowerCase() === loggedUserName.trim().toLowerCase();

                                                                                            return (
                                                                                                <div key={r.id} className="p-2 rounded-2" style={{ background: "rgba(255, 255, 255, 1)", border: "1px solid #f1f3f5" }}>
                                                                                                    <div className="d-flex align-items-start justify-content-between">
                                                                                                        <div style={{ fontSize: 13, fontWeight: 600 }}>{r.author}</div>


                                                                                                        {/* Show action buttons only for owner of the reply */}
                                                                                                        {isOwnReply && (
                                                                                                            <div className="d-flex gap-1">
                                                                                                                {isEditing ? (
                                                                                                                    <>
                                                                                                                        <button
                                                                                                                            className="btn btn-sm btn-outline-secondary"
                                                                                                                            onClick={() => cancelEditReply()}
                                                                                                                        >
                                                                                                                            Cancel
                                                                                                                        </button>

                                                                                                                        <button
                                                                                                                            className="btn btn-sm btn-primary"
                                                                                                                            onClick={() => saveReplyEdit(r.id, c.id)}
                                                                                                                        >
                                                                                                                            Save
                                                                                                                        </button>
                                                                                                                    </>
                                                                                                                ) : (
                                                                                                                    <>
                                                                                                                        {/* <button
                                                              className="btn btn-sm btn-light"
                                                              title="Edit reply"
                                                              onClick={() => startEditReply(r)}
                                                            >
                                                              <i className="bi bi-pencil-fill" style={{ fontSize: 11 }}></i>
                                                            </button> */}

                                                                                                                        <button
                                                                                                                            className="btn btn-sm btn-light text-danger"
                                                                                                                            title="Delete reply"
                                                                                                                            onClick={() => deleteReply(r.id, c.id)}
                                                                                                                        >
                                                                                                                            <i className="bi bi-trash-fill" style={{ fontSize: 11 }}></i>
                                                                                                                        </button>
                                                                                                                    </>
                                                                                                                )}
                                                                                                            </div>
                                                                                                        )}



                                                                                                    </div>

                                                                                                    {/* content or editor */}
                                                                                                    {!isEditing ? (
                                                                                                        <div
                                                                                                            style={{
                                                                                                                fontSize: 13,
                                                                                                                whiteSpace: "pre-wrap",
                                                                                                                overflowWrap: "anywhere",
                                                                                                                wordBreak: "break-word",
                                                                                                                maxWidth: "100%",
                                                                                                                marginTop: 6,
                                                                                                                lineHeight: 1.4,
                                                                                                            }}
                                                                                                        >
                                                                                                            {r.text}
                                                                                                        </div>

                                                                                                    ) : (
                                                                                                        <div style={{ marginTop: 6 }}>
                                                                                                            <div
                                                                                                                ref={replyEditRef}
                                                                                                                contentEditable
                                                                                                                suppressContentEditableWarning
                                                                                                                onInput={() => {
                                                                                                                    setReplyEditContent(replyEditRef.current?.innerHTML || "");
                                                                                                                }}
                                                                                                                style={{
                                                                                                                    minHeight: "80px",
                                                                                                                    outline: "none",
                                                                                                                    textAlign: "left",
                                                                                                                    fontSize: "14px",
                                                                                                                    lineHeight: "1.6",
                                                                                                                    fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
                                                                                                                    overflowY: "auto",
                                                                                                                    whiteSpace: "pre-wrap",
                                                                                                                    wordWrap: "break-word",
                                                                                                                    padding: "6px",
                                                                                                                    border: "1px solid #e6e9ee",
                                                                                                                    borderRadius: 8,
                                                                                                                    background: "#fff"
                                                                                                                }}
                                                                                                            />
                                                                                                            {/* attachments editor for reply edit */}
                                                                                                            <div className="d-flex gap-2 align-items-center mt-2">
                                                                                                                <label className="btn btn-sm btn-outline-secondary mb-0" style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                                                                                                                    📎 Attach
                                                                                                                    <input type="file" multiple onChange={(ev) => {
                                                                                                                        const files = Array.from(ev.target.files || []);
                                                                                                                        const list = files.map((f) => ({ file: f, name: f.name }));
                                                                                                                        setReplyEditAttachments(prev => [...(prev || []), ...list]);
                                                                                                                        ev.target.value = null;
                                                                                                                    }} hidden />
                                                                                                                </label>

                                                                                                                {/* preview existing/new attachments */}
                                                                                                                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                                                                                                                    {(replyEditAttachments || []).map((a, idx) => (
                                                                                                                        <div key={idx} className="badge bg-white text-dark d-inline-flex align-items-center" style={{ padding: "6px 8px", border: "1px solid #e6e9ee", borderRadius: 12 }}>
                                                                                                                            {a.name}
                                                                                                                            <button className="btn btn-sm btn-link text-danger p-0 ms-2" type="button" onClick={() => {
                                                                                                                                setReplyEditAttachments(prev => prev.filter((_, i) => i !== idx));
                                                                                                                            }}>✕</button>
                                                                                                                        </div>
                                                                                                                    ))}
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    )}

                                                                                                    {/* attachments display for non-edit mode */}
                                                                                                    {!isEditing && atts.length > 0 && (
                                                                                                        <div className="mt-2" style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                                                                                                            {atts.map((a, i) => (
                                                                                                                <div key={i} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                                                                                    {a.isImage && a.href ? (
                                                                                                                        <img src={a.href} alt={a.name} style={{ maxWidth: 220, maxHeight: 140, borderRadius: 8, objectFit: "contain", border: "1px solid #ececec" }} />
                                                                                                                    ) : (
                                                                                                                        <a href={a.href || "#"} download={a.href ? a.name : undefined} target={a.href ? "_blank" : undefined} rel={a.href ? "noreferrer" : undefined} className="d-inline-flex align-items-center" style={{ textDecoration: "none", color: "#0d6efd", fontSize: 13 }}>
                                                                                                                            📎 {a.name}
                                                                                                                        </a>
                                                                                                                    )}
                                                                                                                    {!a.href && <div style={{ fontSize: 13, color: "#6c757d" }}>{a.name}</div>}
                                                                                                                </div>
                                                                                                            ))}
                                                                                                        </div>
                                                                                                    )}
                                                                                                </div>
                                                                                            );
                                                                                        })}
                                                                                    </div>
                                                                                )}





                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        ) : (
                                                            <p className="text-muted p-2">No comments yet.</p>
                                                        )}

                                                        {/* Image lightbox / preview (unchanged functionality) */}
                                                        {previewImages.length > 0 && (
                                                            <div
                                                                className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                                                                style={{ background: "rgba(0,0,0,0.72)", zIndex: 2000 }}
                                                                onClick={() => setPreviewImages([])}
                                                            >
                                                                <div className="position-relative" onClick={(e) => e.stopPropagation()}>
                                                                    <img
                                                                        src={previewImages[currentImageIndex]}
                                                                        alt="Preview"
                                                                        style={{ maxHeight: "80vh", maxWidth: "80vw", borderRadius: 8 }}
                                                                    />

                                                                    {currentImageIndex > 0 && (
                                                                        <button
                                                                            className="btn btn-dark position-absolute top-50 start-0 translate-middle-y"
                                                                            style={{ opacity: 0.85 }}
                                                                            onClick={() => setCurrentImageIndex(currentImageIndex - 1)}
                                                                        >
                                                                            ‹
                                                                        </button>
                                                                    )}

                                                                    {currentImageIndex < previewImages.length - 1 && (
                                                                        <button
                                                                            className="btn btn-dark position-absolute top-50 end-0 translate-middle-y"
                                                                            style={{ opacity: 0.85 }}
                                                                            onClick={() => setCurrentImageIndex(currentImageIndex + 1)}
                                                                        >
                                                                            ›
                                                                        </button>
                                                                    )}

                                                                    <button className="btn btn-danger position-absolute top-0 end-0 m-2" onClick={() => setPreviewImages([])}>
                                                                        ✕
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>



                                            </div>

                                            {/* ✅ RIGHT: Sidebar Info */}
                                            <div className="col-md-4 task-modal-emp__sidebar" >
                                                <div
                                                    className="task-modal-emp__sidebar-card"

                                                >
                                                    {/* Header */}
                                                    <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
                                                        <h6 className="fw-bold mb-0">
                                                            <i className="bi bi-info-circle me-2 text-primary"></i>
                                                            Details
                                                        </h6>
                                                        {/* Status */}
                                                        <div>
                                                            {editField === "status" ? (
                                                                <select
                                                                    className="form-select form-select-sm"
                                                                    style={{ width: "140px" }}
                                                                    // prefer editedTask first, fall back to activeTask safely
                                                                    value={editedTask?.status ?? activeTask?.status ?? "PENDING"}
                                                                    onChange={(e) =>
                                                                        setEditedTask((prev) => ({ ...(prev ?? activeTask ?? {}), status: e.target.value }))
                                                                    }
                                                                    onBlur={() => {
                                                                        // guard: only call update if we have both activeTask and editedTask
                                                                        if (!activeTask) {
                                                                            finishEditStatus();
                                                                            return;
                                                                        }
                                                                        const newStatus = editedTask?.status ?? activeTask.status;
                                                                        // only update if changed
                                                                        if (newStatus !== activeTask.status) {
                                                                            updateTaskField(activeTask.id, "status", newStatus);
                                                                        }
                                                                        finishEditStatus();
                                                                    }}
                                                                    autoFocus
                                                                >
                                                                    <option value="PENDING">To Do</option>
                                                                    <option value="IN_PROGRESS">In Progress</option>
                                                                    <option value="REVIEW">Review</option>
                                                                    <option value="READY TO TEST">Ready to Test</option>
                                                                    <option value="IN TESTING">In Testing</option>
                                                                    <option value="COMPLETED">Completed</option>
                                                                    <option value="CANCELLED">Cancelled</option>
                                                                </select>
                                                            ) : (
                                                                <span
                                                                    className={`badge ${getStatusBadge(activeTask?.status)}`}
                                                                    style={{ cursor: "pointer" }}
                                                                    onClick={() => startEditStatus(activeTask)}
                                                                >
                                                                    {(activeTask?.status ?? "PENDING").replace("_", " ")}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* 🧩 Details Table */}
                                                    <div className="table-responsive">
                                                        <table className="table table-borderless align-middle mb-0">
                                                            <tbody>
                                                                {/* Task ID */}
                                                                <tr>
                                                                    <th className="fw-semibold " style={{ width: "45%" }}> Task ID</th>
                                                                    <td className="fw-normal text-start ">{activeTask.taskCode || ""}</td>
                                                                </tr>

                                                                {/* Project */}
                                                                <tr>
                                                                    <th className="fw-semibold">Project</th>
                                                                    <td className="fw-normal text-start">
                                                                        {editField === "project" ? (
                                                                            <select
                                                                                className="form-select form-select-sm"
                                                                                value={activeTask.project?.id || ""}
                                                                                onChange={(e) => {
                                                                                    const selectedId = e.target.value;
                                                                                    setEditedTask({
                                                                                        ...activeTask,
                                                                                        project: projects.find((p) => p.id === Number(selectedId)),
                                                                                    });
                                                                                    updateTaskField(activeTask.id, "projectId", selectedId);
                                                                                    setEditField(null);
                                                                                }}
                                                                                onBlur={() => setEditField(null)}
                                                                                autoFocus
                                                                            >
                                                                                <option value="">Select Project</option>
                                                                                {projects.map((p) => (
                                                                                    <option key={p.id} value={p.id}>
                                                                                        {p.name}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                        ) : (
                                                                            <span
                                                                                className="fw-normal text-start"
                                                                                style={{ cursor: "pointer" }}
                                                                                onClick={() => setEditField("project")}
                                                                            >
                                                                                {activeTask.project ? activeTask.project.name : "—"}
                                                                            </span>
                                                                        )}
                                                                    </td>
                                                                </tr>

                                                                {/* Due Date */}
                                                                <tr>
                                                                    <th className="fw-semibold"> Due Date</th>
                                                                    <td className="fw-normal text-start ">
                                                                        {editField === "dueDate" ? (
                                                                            <input
                                                                                type="date"
                                                                                className="form-control form-control-sm"
                                                                                // Controlled from editedTask with a safe fallback
                                                                                value={
                                                                                    editedTask?.dueDate
                                                                                        ? new Date(editedTask.dueDate).toISOString().split("T")[0]
                                                                                        : ""
                                                                                }
                                                                                onChange={(e) =>
                                                                                    setEditedTask(prev => ({ ...(prev || activeTask || {}), dueDate: e.target.value }))
                                                                                }
                                                                                onBlur={() => {
                                                                                    // guard against activeTask being cleared before blur fires
                                                                                    if (!activeTask) {
                                                                                        setEditField(null);
                                                                                        return;
                                                                                    }

                                                                                    // safe read with fallback
                                                                                    const newDate = editedTask?.dueDate ?? "";
                                                                                    const activeDate = activeTask?.dueDate
                                                                                        ? new Date(activeTask.dueDate).toISOString().split("T")[0]
                                                                                        : "";

                                                                                    // only call update if the date actually changed
                                                                                    if (newDate !== activeDate) {
                                                                                        updateTaskField(activeTask.id, "dueDate", newDate);
                                                                                    }

                                                                                    setEditField(null);
                                                                                }}
                                                                                autoFocus
                                                                            />
                                                                        ) : (
                                                                            <span
                                                                                style={{ cursor: "pointer" }}
                                                                                onClick={() => {
                                                                                    // initialize editedTask when entering edit mode
                                                                                    setEditedTask(activeTask ? { ...activeTask } : {});
                                                                                    setEditField("dueDate");
                                                                                }}
                                                                            >
                                                                                {activeTask?.dueDate
                                                                                    ? new Date(activeTask.dueDate).toLocaleDateString("en-GB")
                                                                                    : "—"}
                                                                            </span>
                                                                        )}
                                                                    </td>
                                                                </tr>


                                                                {/* Priority */}
                                                                <tr>
                                                                    <th className="fw-semibold"> Priority</th>
                                                                    <td className="fw-normal text-start ">
                                                                        {editField === "priority" ? (
                                                                            <select
                                                                                className="form-select form-select-sm"
                                                                                value={activeTask.priority || ""}
                                                                                onChange={(e) =>
                                                                                    setEditedTask({ ...activeTask, priority: e.target.value })
                                                                                }
                                                                                onBlur={() => {
                                                                                    updateTaskField(activeTask.id, "priority", editedTask.priority);
                                                                                    setEditField(null);
                                                                                }}
                                                                                autoFocus
                                                                            >
                                                                                <option value="LOW">Low</option>
                                                                                <option value="MEDIUM">Medium</option>
                                                                                <option value="HIGH">High</option>
                                                                            </select>
                                                                        ) : (
                                                                            <span
                                                                                className={`badge ${activeTask.priority === "HIGH"
                                                                                    ? "bg-danger"
                                                                                    : activeTask.priority === "MEDIUM"
                                                                                        ? "bg-warning text-dark"
                                                                                        : "bg-secondary"
                                                                                    }`}
                                                                                style={{ cursor: "pointer" }}
                                                                                onClick={() => setEditField("priority")}
                                                                            >
                                                                                {activeTask.priority || "Not set"}
                                                                            </span>
                                                                        )}
                                                                    </td>
                                                                </tr>

                                                                {/* Task Type */}
                                                                <tr>
                                                                    <th className="fw-semibold">Task Type</th>
                                                                    <td className="fw-normal text-start">
                                                                        {editField === "taskType" ? (
                                                                            <select
                                                                                ref={selectRef}
                                                                                className="form-select form-select-sm"
                                                                                // prefer editedTask value (if present) otherwise fall back to activeTask
                                                                                value={editedTask?.taskType ?? activeTask?.taskType ?? ""}
                                                                                onChange={(e) =>
                                                                                    // update safely even if editedTask is null for some reason
                                                                                    setEditedTask((prev) => ({ ...(prev ?? activeTask ?? {}), taskType: e.target.value }))
                                                                                }
                                                                                onBlur={() => {
                                                                                    // defensive guards before saving
                                                                                    const taskId = activeTask?.id;
                                                                                    const newTaskType = editedTask?.taskType ?? activeTask?.taskType;

                                                                                    // if no taskId then just close edit mode
                                                                                    if (!taskId) {
                                                                                        setEditField(null);
                                                                                        return;
                                                                                    }

                                                                                    // Only call update if value actually changed (optional)
                                                                                    if (newTaskType !== activeTask?.taskType) {
                                                                                        updateTaskField(taskId, "taskType", newTaskType);
                                                                                    }

                                                                                    setEditField(null);
                                                                                }}
                                                                                autoFocus
                                                                            >
                                                                                <option value="">Select</option>
                                                                                <option value="Task">Task</option>
                                                                                <option value="Bug">Bug</option>
                                                                                <option value="Feature">Feature</option>
                                                                                <option value="Improvement">Improvement</option>
                                                                                <option value="Research">Research</option>
                                                                                <option value="Documentation">Documentation</option>
                                                                            </select>
                                                                        ) : (
                                                                            <span
                                                                                onClick={() => {
                                                                                    // initialize editedTask if activeTask exists, then open editor
                                                                                    if (activeTask) setEditedTask({ ...activeTask });
                                                                                    setEditField("taskType");
                                                                                }}
                                                                                style={{ cursor: "pointer" }}
                                                                            >
                                                                                {activeTask?.taskType || "Click to select"}
                                                                            </span>
                                                                        )}
                                                                    </td>
                                                                </tr>


                                                                {/* Team */}
                                                                {/* <tr>
                                                                    <th className="fw-semibold"> Team</th>
                                                                    <td className="fw-normal text-start ">
                                                                        {editField === "team" ? (
                                                                        <select
                                                                            className="form-select form-select-sm"
                                                                            value={activeTask.team?.id || ""}
                                                                            onChange={(e) => {
                                                                            const selectedTeam = teams.find(
                                                                                (t) => t.id === parseInt(e.target.value)
                                                                            );
                                                                            setEditedTask({ ...activeTask, team: selectedTeam });
                                                                            }}
                                                                            onBlur={() => {
                                                                            updateTaskField(activeTask.id, "team", editedTask.team);
                                                                            setEditField(null);
                                                                            }}
                                                                            autoFocus
                                                                        >
                                                                            <option value="">Select Team</option>
                                                                            {teams.map((team) => (
                                                                            <option key={team.id} value={team.id}>
                                                                                {team.name}
                                                                            </option>
                                                                            ))}
                                                                        </select>
                                                                        ) : (
                                                                        <span
                                                                            style={{ cursor: "pointer" }}
                                                                            onClick={() => setEditField("team")}
                                                                        >
                                                                            {activeTask.team ? activeTask.team.name : "Click to select"}
                                                                        </span>
                                                                        )}
                                                                    </td>
                                                                    </tr> */}
                                                                <tr>
                                                                    <th className="fw-semibold"> Team</th>
                                                                    <td className="fw-normal text-start ">
                                                                        {editField === "team" ? (
                                                                            <select
                                                                                className="form-select form-select-sm"
                                                                                // prefer editedTask first, then activeTask; stringify to avoid type mismatch
                                                                                value={
                                                                                    String(editedTask?.team?.id ?? activeTask?.team?.id ?? "")
                                                                                }
                                                                                onChange={(e) => {
                                                                                    const val = e.target.value;
                                                                                    // treat empty string as no team
                                                                                    const teamId = val === "" ? null : Number(val);
                                                                                    // update editedTask.team to an object with id, so display still works
                                                                                    const selectedTeam = teamId == null ? null : (teams.find(t => t.id === teamId) ?? { id: teamId });

                                                                                    setEditedTask(prev => ({
                                                                                        ...(prev ?? (activeTask ?? {})),
                                                                                        team: selectedTeam
                                                                                    }));
                                                                                }}
                                                                                onBlur={async () => {
                                                                                    // defensive guards
                                                                                    const taskId = activeTask?.id;
                                                                                    if (!taskId) { setEditField(null); return; }

                                                                                    // derive the chosen team id (may be null)
                                                                                    const newTeamId = editedTask?.team?.id ?? null;
                                                                                    const prevTeamId = activeTask?.team?.id ?? null;

                                                                                    // only update if changed
                                                                                    if (newTeamId !== prevTeamId) {
                                                                                        try {
                                                                                            // Call backend with teamId (not the whole team object).
                                                                                            // Adjust key name to match your API; using "teamId" because other fields used "employeeId".
                                                                                            await updateTaskField(taskId, "teamId", newTeamId);

                                                                                            // optimistic local update so UI shows new team immediately:
                                                                                            applyLocalTaskUpdate({ team: newTeamId == null ? null : (teams.find(t => t.id === newTeamId) ?? { id: newTeamId }) });

                                                                                            // Optionally: refetch or reconcile with server response if updateTaskField returns updated task.
                                                                                        } catch (err) {
                                                                                            console.error("Failed to update team:", err);
                                                                                            // optionally show toast
                                                                                        }
                                                                                    }

                                                                                    setEditField(null);
                                                                                }}
                                                                                autoFocus
                                                                            >
                                                                                <option value="">Select Team</option>
                                                                                {teams.map(team => (
                                                                                    // option value must be string to match select value type above
                                                                                    <option key={team.id} value={String(team.id)}>
                                                                                        {team.name}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                        ) : (
                                                                            <span
                                                                                style={{ cursor: "pointer" }}
                                                                                onClick={() => {
                                                                                    if (!activeTask) return;
                                                                                    setEditedTask({ ...activeTask });
                                                                                    setEditField("team");
                                                                                }}
                                                                            >
                                                                                {activeTask?.team ? activeTask.team.name : "Click to select"}
                                                                            </span>
                                                                        )}
                                                                    </td>
                                                                </tr>



                                                                {/* Estimated Time */}
                                                                <tr>
                                                                    <th className="fw-semibold">Estimated Time</th>
                                                                    <td className="fw-normal text-start">
                                                                        {editField === "estimatedTime" ? (
                                                                            <input
                                                                                type="number"
                                                                                className="form-control form-control-sm"
                                                                                value={editedTask.estimatedTime || ""}
                                                                                onChange={(e) =>
                                                                                    setEditedTask({ ...editedTask, estimatedTime: e.target.value })
                                                                                }
                                                                                onBlur={() => {
                                                                                    updateTaskField(activeTask.id, "estimatedTime", editedTask.estimatedTime);
                                                                                    setEditField(null);
                                                                                }}
                                                                                autoFocus
                                                                            />
                                                                        ) : (
                                                                            <span
                                                                                style={{ cursor: "pointer" }}
                                                                                onClick={() => {
                                                                                    setEditedTask({ ...activeTask });
                                                                                    setEditField("estimatedTime");
                                                                                }}
                                                                            >
                                                                                {activeTask.estimatedTime || 0} hr
                                                                            </span>
                                                                        )}
                                                                    </td>
                                                                </tr>

                                                                {/* Total Logged Time */}
                                                                {/* <tr>
                                                                    <th className="fw-semibold"> Total Time</th>
                                                                    <td className="fw-normal text-start ">{activeTask.totalTime || 0} hr</td>
                                                                </tr> */}

                                                                {/* Assignee */}
                                                                <tr>
                                                                    <th className="fw-semibold"> Assignee</th>
                                                                    <td>
                                                                        {editField === "assignee" ? (
                                                                            <select
                                                                                className="form-select form-select-sm"
                                                                                value={activeTask.assignedTo?.id || ""}
                                                                                onChange={(e) => {
                                                                                    const selectedId = e.target.value;
                                                                                    setEditedTask({
                                                                                        ...activeTask,
                                                                                        assignedTo: employees.find(
                                                                                            (emp) => emp.id === Number(selectedId)
                                                                                        ),
                                                                                    });
                                                                                    updateTaskField(activeTask.id, "employeeId", selectedId);
                                                                                    setEditField(null);
                                                                                }}
                                                                                onBlur={() => setEditField(null)}
                                                                                autoFocus
                                                                            >
                                                                                <option value="">Select Employee</option>
                                                                                {employees.map((emp) => (
                                                                                    <option key={emp.id} value={emp.id}>
                                                                                        {emp.firstName} {emp.lastName}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                        ) : activeTask.assignedTo ? (
                                                                            <div
                                                                                className="d-flex align-items-center gap-2"
                                                                                style={{ cursor: "pointer" }}
                                                                                onClick={() => setEditField("assignee")}
                                                                            >
                                                                                <img
                                                                                    src={
                                                                                        activeTask?.assignedTo?.photoPath
                                                                                            ? `/uploads/${activeTask.assignedTo.photoPath}`
                                                                                            : "/default-avatar.png"
                                                                                    }
                                                                                    alt="Assignee"
                                                                                    className="rounded-circle border border-2 border-white"
                                                                                    style={{ width: "26px", height: "26px", objectFit: "cover" }}
                                                                                />

                                                                                <span className="fw-normal">
                                                                                    {activeTask.assignedTo.firstName}{" "}
                                                                                    {activeTask.assignedTo.lastName}
                                                                                </span>
                                                                            </div>
                                                                        ) : (
                                                                            <span
                                                                                className="fw-normal text-start "
                                                                                style={{ cursor: "pointer" }}
                                                                                onClick={() => setEditField("assignee")}
                                                                            >
                                                                                Unassigned
                                                                            </span>
                                                                        )}
                                                                    </td>
                                                                </tr>

                                                                {/* Reporter */}
                                                                <tr>
                                                                    <th className="fw-semibold"> Reporter</th>
                                                                    <td>
                                                                        {activeTask.reporter ? (
                                                                            <div className="d-flex align-items-center gap-2">
                                                                                <img
                                                                                    src={
                                                                                        activeTask.reporter.photoPath
                                                                                            ? `/uploads/${activeTask.reporter.photoPath}`
                                                                                            : "/default-avatar.png"
                                                                                    }
                                                                                    alt="Reporter"
                                                                                    className="rounded-circle border border-2 border-white"
                                                                                    style={{ width: "26px", height: "26px", objectFit: "cover" }}
                                                                                />
                                                                                <span className="fw-normal text-start">
                                                                                    {activeTask.reporter.firstName} {activeTask.reporter.lastName}
                                                                                </span>
                                                                            </div>
                                                                        ) : (
                                                                            <span className="fw-normal text-start ">Unassigned</span>
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                                {/* TimeStack card (below Details) — COLLAPSIBLE */}
                                                <div className="task-modal-emp__sidebar-card mt-3 task-modal-emp__timestack">
                                                    <button
                                                        type="button"
                                                        className="task-modal-emp__timestack-header d-flex justify-content-between align-items-center border-0 w-100 p-0"
                                                        onClick={() => setTimeStackOpen(prev => !prev)}
                                                        aria-expanded={timeStackOpen}
                                                        aria-controls="timestack-body"
                                                        style={{ background: "transparent", cursor: "pointer" }}
                                                    >
                                                        <div className="d-flex align-items-center">
                                                            <i className="bi bi-clock-history me-2 text-primary" />
                                                            <h6 className="fw-bold mb-0">TimeStack</h6>
                                                        </div>

                                                        <div className="d-flex align-items-center">
                                                            {/* optional: show a small summary on the right (logged or estimated) */}
                                                            <small className="text-muted me-2">
                                                                {loggedHrs > 0 ? formatH(loggedHrs) : (activeTask?.estimatedTime ? "0h" : "")}
                                                            </small>

                                                            <i
                                                                className={`bi ${timeStackOpen ? "bi-chevron-up" : "bi-chevron-down"}`}
                                                                aria-hidden="true"
                                                            />
                                                        </div>
                                                    </button>

                                                    <div
                                                        id="timestack-body"
                                                        className={`task-modal-emp__timestack-body ${timeStackOpen ? "is-open" : "is-closed"}`}
                                                        aria-hidden={!timeStackOpen}
                                                    >
                                                        <div className="table-responsive">
                                                            <table className="table table-borderless align-middle mb-0">
                                                                <tbody>
                                                                    {/* Estimated */}
                                                                    <tr>
                                                                        <th className="fw-semibold" style={{ width: "55%" }}>Estimated</th>
                                                                        <td className="fw-normal text-start">
                                                                            {activeTask?.estimatedTime ? `${estimatedHrs} hr` : "Not specified"}
                                                                        </td>
                                                                    </tr>

                                                                    {/* Remaining */}
                                                                    <tr>
                                                                        <th className="fw-semibold">Remaining</th>
                                                                        <td className="fw-normal text-start">
                                                                            {activeTask?.estimatedTime ? `${remainingHrs} hr` : "Not specified"}
                                                                        </td>
                                                                    </tr>

                                                                    {/* Logged */}
                                                                    <tr>
                                                                        <th className="fw-semibold">Logged</th>
                                                                        <td className="fw-normal text-start">
                                                                            {loggedHrs > 0 ? `${loggedHrs} hr` : "Not logged yet"}
                                                                        </td>
                                                                    </tr>

                                                                    {/* Total Time (all employees) */}
                                                                    <tr>
                                                                        <th className="fw-semibold">Total</th>
                                                                        <td className="fw-normal text-start">
                                                                            {taskTotalHrs == null
                                                                                ? "Not available"
                                                                                : taskTotalHrs > 0
                                                                                    ? `${taskTotalHrs} hr`
                                                                                    : "0 hr"}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>




                                        </div>
                                        {/* END ROW */}
                                    </div>
                                    {/* END MODAL BODY */}
                                </div>
                                {/*  END MODAL CONTENT */}
                            </div>
                            {/*  END MODAL DIALOG */}
                        </div>
                        {/* END MODAL */}
                    </>
                )}


            </div>
        </>
    );
};

export default ViewTaskss;
